import styled from 'styled-components';

const StyledSVG = styled.svg`
  .cls-1 {
    fill: #8262bb;
  }
  .cls-1,
  .cls-2,
  .cls-3,
  .cls-4,
  .cls-5,
  .cls-6,
  .cls-7,
  .cls-8,
  .cls-9,
  .cls-10,
  .cls-11,
  .cls-12,
  .cls-13,
  .cls-14,
  .cls-15,
  .cls-16,
  .cls-17,
  .cls-18,
  .cls-19,
  .cls-20,
  .cls-21,
  .cls-22,
  .cls-23,
  .cls-24,
  .cls-25,
  .cls-26,
  .cls-27,
  .cls-28,
  .cls-29,
  .cls-30,
  .cls-31,
  .cls-32,
  .cls-33,
  .cls-34,
  .cls-35,
  .cls-36,
  .cls-37,
  .cls-38,
  .cls-39,
  .cls-40,
  .cls-41,
  .cls-42,
  .cls-43,
  .cls-44,
  .cls-45,
  .cls-46,
  .cls-47,
  .cls-48,
  .cls-49,
  .cls-50,
  .cls-51,
  .cls-52,
  .cls-53,
  .cls-54,
  .cls-55,
  .cls-56,
  .cls-57,
  .cls-58,
  .cls-59,
  .cls-60,
  .cls-61,
  .cls-62,
  .cls-63,
  .cls-64,
  .cls-65,
  .cls-66 {
    stroke-width: 0px;
  }
  .cls-2 {
    fill: #83a131;
  }
  .cls-3 {
    fill: url(#linear-gradient-12);
  }
  .cls-4 {
    fill: #4e3a60;
  }
  .cls-5 {
    fill: #271618;
  }
  .cls-6 {
    fill: #755ec2;
  }
  .cls-7 {
    fill: url(#linear-gradient);
  }
  .cls-8 {
    fill: #56416b;
  }
  .cls-9 {
    fill: #5b913a;
  }
  .cls-10 {
    fill: #e6e8f5;
  }
  .cls-11 {
    fill: #ecc4d1;
  }
  .cls-12 {
    fill: #a289dd;
  }
  .cls-13 {
    fill: #5a3012;
  }
  .cls-14 {
    fill: url(#linear-gradient-6);
  }
  .cls-15,
  .cls-49 {
    fill: #d4b79f;
  }
  .cls-16 {
    fill: #473b6a;
  }
  .cls-17 {
    fill: #a89bdd;
  }
  .cls-18 {
    fill: #2a170d;
  }
  .cls-19 {
    fill: #463a5b;
  }
  .cls-20 {
    fill: #351f1c;
  }
  .cls-67 {
    clip-path: url(#clippath-2);
  }
  .cls-68 {
    isolation: isolate;
  }
  .cls-21 {
    fill: #eff2f3;
  }
  .cls-22 {
    fill: #534061;
  }
  .cls-23 {
    fill: #aa6928;
  }
  .cls-69 {
    clip-path: url(#clippath-6);
  }
  .cls-24 {
    fill: url(#linear-gradient-11);
  }
  .cls-25 {
    fill: #f2f9fb;
  }
  .cls-26 {
    fill: #594992;
  }
  .cls-27 {
    fill: url(#linear-gradient-5);
  }
  .cls-28 {
    fill: #674a9f;
  }
  .cls-29 {
    fill: none;
  }
  .cls-30 {
    fill: #467428;
  }
  .cls-31 {
    fill: #8f76c3;
  }
  .cls-70 {
    clip-path: url(#clippath-4);
  }
  .cls-32,
  .cls-49 {
    mix-blend-mode: multiply;
    opacity: 0.2;
  }
  .cls-32,
  .cls-66 {
    fill: #bda4bd;
  }
  .cls-33 {
    fill: #f3dec9;
  }
  .cls-34 {
    fill: url(#linear-gradient-13);
  }
  .cls-35 {
    fill: #ebb867;
  }
  .cls-36 {
    fill: #b56154;
  }
  .cls-37 {
    fill: #875567;
  }
  .cls-38 {
    fill: url(#linear-gradient-14);
  }
  .cls-39 {
    fill: url(#linear-gradient-2);
  }
  .cls-40 {
    fill: #42220f;
  }
  .cls-41 {
    fill: #e1a79f;
  }
  .cls-42 {
    fill: #94a2d3;
  }
  .cls-43 {
    fill: #6d5eb3;
  }
  .cls-44 {
    fill: url(#linear-gradient-7);
  }
  .cls-45 {
    fill: #ad9dbf;
  }
  .cls-46 {
    fill: url(#linear-gradient-3);
  }
  .cls-71 {
    clip-path: url(#clippath);
  }
  .cls-47 {
    fill: #3d6820;
  }
  .cls-48 {
    fill: url(#linear-gradient-9);
  }
  .cls-50 {
    fill: #a85f16;
  }
  .cls-51 {
    fill: #83a031;
  }
  .cls-52 {
    fill: url(#linear-gradient-8);
  }
  .cls-53 {
    fill: #4a2b53;
  }
  .cls-54 {
    fill: #55498e;
  }
  .cls-55 {
    fill: #beade2;
  }
  .cls-56 {
    fill: url(#linear-gradient-10);
  }
  .cls-57 {
    fill: #68699d;
  }
  .cls-58 {
    fill: #56587f;
  }
  .cls-59 {
    fill: url(#linear-gradient-4);
  }
  .cls-60 {
    fill: #1e0d0e;
  }
  .cls-61 {
    fill: #884b12;
  }
  .cls-62 {
    fill: #393152;
  }
  .cls-63 {
    fill: #5d4570;
  }
  .cls-64 {
    fill: #514287;
  }
  .cls-65 {
    fill: #413767;
  }
`;

const TV_PHD_3D = () => {
  return (
    <StyledSVG xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 665.34 686.75">
      <defs>
        <clipPath id="clippath">
          <polygon
            className="cls-29"
            points="-271.19 -10.15 -271.19 94.31 -230.28 103.97 -230.28 234.55 -396.38 330.4 -414.8 341.04 -494.34 386.95 -571.42 431.45 -571.42 163.15 -463.9 101.07 -463.9 130.98 -447.9 135.03 -419.87 162.4 -419.88 343.97 -374.85 317.9 -374.91 57.3 -371.34 52.05 -368.62 46.07 -271.19 -10.15"
          />
        </clipPath>
        <clipPath id="clippath-2">
          <polygon className="cls-29" points="258.05 -5.45 -577.28 476.81 -577.28 155.3 258.05 -326.96 258.05 -5.45" />
        </clipPath>
        <linearGradient
          id="linear-gradient"
          x1="-197.51"
          y1="236.49"
          x2="-197.51"
          y2="397.28"
          gradientTransform="translate(11.43 -260.34) rotate(-30) scale(1 .87) skewX(-26.57)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#68519c" />
          <stop offset="1" stop-color="#4a3b79" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="-59.66"
          y1="279.06"
          x2="-6.95"
          y2="279.06"
          gradientTransform="translate(11.43 -260.34) rotate(-30) scale(1 .87) skewX(-26.57)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#ac9fde" />
          <stop offset=".16" stop-color="#ab9fde" />
          <stop offset="1" stop-color="#ab9fde" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-3"
          x1="-59.66"
          y1="279.06"
          x2="-6.95"
          y2="279.06"
          gradientTransform="translate(11.43 -260.34) rotate(-30) scale(1 .87) skewX(-26.57)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#ab9fde" />
          <stop offset="1" stop-color="#ab9fde" />
        </linearGradient>
        <linearGradient id="linear-gradient-4" x1="-41.87" y1="284.21" y2="284.21" xlinkHref="#linear-gradient-3" />
        <clipPath id="clippath-4">
          <polygon
            className="cls-29"
            points="-271.19 745.9 -271.19 850.37 -230.28 860.03 -230.28 990.61 -396.38 1086.46 -414.8 1097.1 -494.34 1143.01 -571.42 1187.51 -571.42 919.21 -463.9 857.13 -463.9 887.04 -447.9 891.09 -419.87 918.45 -419.88 1100.03 -374.85 1073.96 -374.91 813.36 -371.34 808.11 -368.62 802.13 -271.19 745.9"
          />
        </clipPath>
        <clipPath id="clippath-6">
          <polygon
            className="cls-29"
            points="258.05 750.61 -577.28 1232.87 -577.28 911.36 258.05 429.09 258.05 750.61"
          />
        </clipPath>
        <linearGradient
          id="linear-gradient-5"
          x1="-197.51"
          y1="992.55"
          x2="-197.51"
          y2="1153.34"
          gradientTransform="translate(11.43 -260.34) rotate(-30) scale(1 .87) skewX(-26.57)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#9d756f" />
          <stop offset="1" stop-color="#7f443b" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-6"
          x1="164.85"
          y1="1035.13"
          x2="217.56"
          y2="1035.13"
          gradientTransform="translate(11.43 -260.34) rotate(-30) scale(1 .87) skewX(-26.57)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#bff9ef" />
          <stop offset=".16" stop-color="#bef9ef" />
          <stop offset="1" stop-color="#cdfff8" />
        </linearGradient>
        <linearGradient
          id="linear-gradient-7"
          x1="164.85"
          y1="1017.89"
          x2="175.58"
          y2="1017.89"
          gradientTransform="translate(11.43 -260.34) rotate(-30) scale(1 .87) skewX(-26.57)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#9be5d5" />
          <stop offset="1" stop-color="#a7ebe4" />
        </linearGradient>
        <linearGradient id="linear-gradient-8" y1="1024.75" x2="189.32" y2="1024.75" xlinkHref="#linear-gradient-7" />
        <linearGradient id="linear-gradient-9" y1="1035.13" x2="217.56" y2="1035.13" xlinkHref="#linear-gradient-7" />
        <linearGradient
          id="linear-gradient-10"
          x1="182.64"
          y1="1040.27"
          x2="217.56"
          y2="1040.27"
          xlinkHref="#linear-gradient-7"
        />
        <linearGradient
          id="linear-gradient-11"
          x1="119.1"
          y1="1020.06"
          x2="152.55"
          y2="1020.06"
          xlinkHref="#linear-gradient-7"
        />
        <linearGradient
          id="linear-gradient-12"
          x1="119.1"
          y1="1017.66"
          x2="130.86"
          y2="1017.66"
          xlinkHref="#linear-gradient-6"
        />
        <linearGradient
          id="linear-gradient-13"
          x1="119.11"
          y1="1020.01"
          x2="135.58"
          y2="1020.01"
          xlinkHref="#linear-gradient-6"
        />
        <linearGradient
          id="linear-gradient-14"
          x1="125.42"
          y1="1020.06"
          x2="152.55"
          y2="1020.06"
          xlinkHref="#linear-gradient-6"
        />
      </defs>
      <g className="cls-68">
        <g id="Newspaper">
          <g className="cls-71">
            <g className="cls-67">
              <polygon
                className="cls-12"
                points="258.05 -5.45 -577.28 476.81 -577.28 155.3 258.05 -326.96 258.05 -5.45"
              />
              <polygon
                className="cls-7"
                points="258.05 -5.45 -577.28 476.81 -577.28 316.05 258.05 -166.21 258.05 -5.45"
              />
              <path
                className="cls-26"
                d="M386.9-162.36L-158.85,152.72c-6.15,3.55-11.14.67-11.14-6.43s4.99-15.74,11.14-19.29L386.9-188.08c6.15-3.55,11.14-.67,11.14,6.43,0,7.1-4.99,15.74-11.14,19.29Z"
              />
              <polygon className="cls-64" points="265 136.41 -656.72 668.56 -656.72 510.39 265 -21.75 265 136.41" />
              <path
                className="cls-16"
                d="M529.15-193.05L-16.59,122.03c-6.15,3.55-11.14.67-11.14-6.43,0-7.1,4.99-15.74,11.14-19.29L529.15-218.77c6.15-3.55,11.14-.67,11.14,6.43s-4.99,15.74-11.14,19.29Z"
              />
              <path
                className="cls-17"
                d="M185.32-35.07L66.52,33.52c-6.15,3.55-11.14.67-11.14-6.43s4.99-15.74,11.14-19.29l118.8-68.59c6.15-3.55,11.14-.67,11.14,6.43s-4.99,15.74-11.14,19.29Z"
              />
              <polygon className="cls-54" points="53.47 -86.61 53.47 24.14 49.42 26.48 49.42 -84.27 53.47 -86.61" />
              <polygon className="cls-26" points="50.54 -84.92 49.42 -84.27 49.42 26.48 50.55 25.83 50.54 -84.92" />
              <polygon className="cls-20" points="53.47 3.63 53.47 8.3 49.42 10.64 49.42 5.97 53.47 3.63" />
              <polygon className="cls-20" points="53.47 10.64 53.47 15.33 49.42 17.67 49.42 12.99 53.47 10.64" />
              <polygon className="cls-20" points="53.47 17.4 53.47 22.08 49.42 24.42 49.42 19.74 53.47 17.4" />
              <polygon className="cls-19" points="33.49 -71.82 33.49 -47.93 -77.2 15.97 -77.2 -7.92 33.49 -71.82" />
              <polygon className="cls-11" points="38.87 26.66 -80 95.29 -80 32.16 38.87 -36.47 38.87 26.66" />
              <polygon className="cls-20" points="41.27 -37.86 -83.15 33.97 -83.15 29.71 41.27 -42.12 41.27 -37.86" />
              <polygon className="cls-20" points="29.58 29.9 -42.93 71.76 -42.93 24.16 29.58 -17.71 29.58 29.9" />
              <polygon className="cls-39" points="5.41 -.41 5.41 44.81 -40.23 71.16 -40.23 25.95 5.41 -.41" />
              <polygon
                className="cls-60"
                points="26.87 -12.8 5.41 -.41 5.41 44.81 5.41 45.98 27.55 33.2 27.55 -13.19 26.87 -12.8"
              />
              <polygon
                className="cls-46"
                points="5.41 -.41 5.41 7.2 -27.16 63.61 -40.23 71.16 -40.23 68.54 -3.35 4.65 5.41 -.41"
              />
              <polygon className="cls-59" points="5.41 9.88 5.41 14.05 -21.22 60.18 -24.82 62.26 5.41 9.88" />
              <polygon className="cls-20" points="6.52 44.17 4.4 45.39 4.4 -1.23 6.52 -2.45 6.52 44.17" />
              <polygon className="cls-22" points="43.11 -57.85 -85.82 16.58 -85.83 31.26 43.11 -43.17 43.11 -57.85" />
              <polygon
                className="cls-32"
                points="38.87 -36.47 38.87 -33.74 -13.44 56.86 -80 95.28 -80 32.16 38.87 -36.47"
              />
              <polygon className="cls-42" points="34.28 47.87 14.26 59.42 14.26 55.37 34.28 43.81 34.28 47.87" />
              <polygon className="cls-20" points="38.68 28.9 38.68 39.47 -47.64 89.31 -47.64 78.73 38.68 28.9" />
              <polygon className="cls-5" points="5.41 48.1 5.41 58.68 4.4 59.26 4.4 48.69 5.41 48.1" />
              <polygon className="cls-5" points="11.45 44.62 11.45 55.19 10.44 55.78 10.44 45.2 11.45 44.62" />
              <polygon className="cls-5" points="17.49 41.13 17.49 51.7 16.48 52.29 16.48 41.71 17.49 41.13" />
              <polygon className="cls-5" points="23.54 37.64 23.54 48.21 22.53 48.8 22.53 38.22 23.54 37.64" />
              <polygon className="cls-5" points="29.58 34.15 29.58 44.73 28.57 45.31 28.57 34.73 29.58 34.15" />
              <polygon className="cls-5" points="35.62 30.66 35.62 41.24 34.61 41.82 34.61 31.25 35.62 30.66" />
              <polygon className="cls-66" points="41.28 29.53 -47.64 80.87 -47.64 76.61 41.28 25.27 41.28 29.53" />
              <polygon className="cls-66" points="41.28 41.19 -47.64 92.52 -47.64 89.31 41.27 37.98 41.28 41.19" />
              <polygon className="cls-5" points="41.28 26.34 -47.64 77.68 -47.64 76.61 41.28 25.27 41.28 26.34" />
              <polygon className="cls-5" points="25.87 34.7 22.66 36.55 22.66 -27.11 25.87 -28.97 25.87 34.7" />
              <polygon className="cls-10" points="41.27 8.99 -47.64 60.32 -47.64 56.06 41.27 4.73 41.27 8.99" />
              <polygon className="cls-10" points="41.28 25.27 -47.64 76.61 -47.64 72.35 41.28 21.01 41.28 25.27" />
              <polygon className="cls-10" points="12.33 40.81 8.63 42.95 8.63 25.7 12.33 23.57 12.33 40.81" />
              <polygon className="cls-54" points="33.49 -64.83 33.49 -63.66 -77.2 .24 -77.2 -.92 33.49 -64.83" />
              <polygon className="cls-54" points="33.49 -60.75 33.49 -59.59 -77.2 4.32 -77.2 3.16 33.49 -60.75" />
              <polygon className="cls-54" points="33.49 -56.67 33.49 -55.51 -77.2 8.4 -77.2 7.24 33.49 -56.67" />
              <polygon className="cls-42" points="146.78 -17.09 114.43 1.59 114.43 -4.79 146.78 -23.47 146.78 -17.09" />
              <polygon className="cls-5" points="111.28 -31.43 114.43 -33.25 114.43 1.59 111.28 3.41 111.28 -31.43" />
              <polygon className="cls-20" points="98.95 34.27 104.66 30.98 104.66 37.07 98.95 40.37 98.95 34.27" />
              <path
                className="cls-65"
                d="M125.07,11.93c-.28.52-.57,1.01-.87,1.51-4.22,6.93-10.4,11-14.28,9.2-4.14-1.92-4.08-9.83.13-17.67,4.22-7.84,10.99-12.63,15.13-10.71,1.68.78,2.67,2.56,2.97,4.9.18,1.4.11,3.02-.21,4.77-.23,1.31-.61,2.69-1.13,4.1-.46,1.28-1.05,2.59-1.75,3.9Z"
              />
              <path
                className="cls-62"
                d="M124.84-5.87c-4.17-1.51-10.68,3.21-14.78,10.83-4.1,7.62-4.26,15.3-.45,17.48l15.23-28.31Z"
              />
              <path
                className="cls-58"
                d="M117.75,5.86c.41-.75,1.1-1.2,1.55-.99h0c.45.21.49.99.08,1.74l-11.09,20.63c-.41.75-1.1,1.2-1.55.99h0c-.45-.21-.49-.99-.08-1.74l11.1-20.63Z"
              />
              <path
                className="cls-16"
                d="M127.96,3.93l-6.42,1.68c-.3.08-.57.05-.78-.05-.54-.24-.8-.98-.6-1.95.3-1.38,1.38-2.73,2.43-2.99l5.57-1.46c.18,1.4.11,3.02-.21,4.77Z"
              />
              <path
                className="cls-16"
                d="M125.07,11.93c-.28.52-.57,1.01-.87,1.51l-7.98,2.07c-.31.08-.58.07-.81-.04-.52-.24-.77-.99-.58-1.96.3-1.38,1.38-2.71,2.43-2.99l9.56-2.49c-.46,1.28-1.05,2.59-1.75,3.9Z"
              />
              <path
                className="cls-65"
                d="M111.91,4.06c0,.48-.03.97-.06,1.46-.53,6.91-4.83,14.54-10.05,17.55-5.58,3.22-10.1-.07-10.1-7.34,0-7.27,4.52-15.78,10.1-19,2.27-1.31,4.36-1.54,6.05-.87,1.01.4,1.88,1.13,2.55,2.14.51.76.9,1.69,1.15,2.77.24.97.37,2.07.37,3.28Z"
              />
              <path
                className="cls-62"
                d="M101.35-2.97c-5.37,3.4-9.65,11.63-9.65,18.71,0,7.08,4.28,10.36,9.65,7.57V-2.97Z"
              />
              <path
                className="cls-58"
                d="M100.51,8.67c0-.7.49-1.55,1.09-1.9h0c.61-.35,1.1-.07,1.1.63v19.14c0,.7-.49,1.55-1.1,1.9h0c-.6.35-1.1.07-1.1-.63V8.67Z"
              />
              <path
                className="cls-16"
                d="M110.39-1.99l-5.94,6.89c-.28.32-.58.57-.87.74-.72.42-1.42.37-1.78-.22-.48-.85-.09-2.45.88-3.57l5.16-5.98c1.01.4,1.88,1.13,2.55,2.14Z"
              />
              <path
                className="cls-16"
                d="M111.91,4.06c0,.48-.03.97-.06,1.46l-7.4,8.56c-.28.32-.58.58-.88.76-.71.41-1.41.34-1.76-.24-.48-.85-.09-2.44.88-3.57L111.54.78c.24.97.37,2.07.37,3.28Z"
              />
              <path
                className="cls-65"
                d="M92.78,15.06c.3.15.58.33.85.53,3.82,2.74,4.15,9.69.59,16.16-3.8,6.9-10.62,10.64-15.23,8.34-4.61-2.3-5.26-9.77-1.45-16.67,1.55-2.81,3.59-5.09,5.78-6.66,1.31-.94,2.68-1.62,4.02-2.01,1.01-.29,2.01-.41,2.96-.34.87.06,1.7.26,2.47.65Z"
              />
              <path
                className="cls-62"
                d="M77.25,23.98c-3.47,6.74-2.74,13.86,1.74,16.1,4.48,2.24,11.04-1.25,14.9-7.79l-16.65-8.31Z"
              />
              <path
                className="cls-58"
                d="M83.74,28.55c-.44-.22-.46-1.01-.05-1.76h0c.41-.75,1.11-1.18,1.55-.96l12.12,6.05c.45.22.47,1.01.05,1.76h0c-.41.75-1.11,1.18-1.55.95l-12.13-6.05Z"
              />
              <path
                className="cls-16"
                d="M87.35,14.74l-1.86,8.45c-.09.39-.26.8-.45,1.16-.49.89-1.25,1.61-2,1.8-1.04.24-1.65-.68-1.33-2.07l1.62-7.33c1.31-.94,2.68-1.62,4.02-2.01Z"
              />
              <path
                className="cls-16"
                d="M92.78,15.06c.3.15.58.33.85.53l-2.33,10.52c-.09.4-.24.8-.45,1.18-.49.88-1.26,1.59-2,1.78-1.04.24-1.64-.68-1.33-2.07l2.78-12.59c.87.06,1.7.26,2.47.65Z"
              />
              <path
                className="cls-54"
                d="M108.34,26.93c0,2.06-1.44,4.58-3.24,5.62l-6.69,3.86c-1.79,1.03-3.24.19-3.24-1.87,0-1.04.37-2.19.95-3.21.58-1.01,1.39-1.9,2.29-2.42l6.69-3.86c1.8-1.04,3.24-.19,3.24,1.89Z"
              />
              <path
                className="cls-26"
                d="M99.13,28.49v7.5l-.72.42c-1.79,1.03-3.24.19-3.24-1.87,0-1.04.37-2.19.95-3.21.58-1.01,1.39-1.9,2.29-2.42l.72-.42Z"
              />
            </g>
          </g>
          <g className="cls-70">
            <g className="cls-69">
              <polygon
                className="cls-41"
                points="258.05 750.61 -577.28 1232.87 -577.28 911.36 258.05 429.09 258.05 750.61"
              />
              <polygon
                className="cls-27"
                points="258.05 750.61 -577.28 1232.87 -577.28 1072.11 258.05 589.85 258.05 750.61"
              />
              <path
                className="cls-36"
                d="M386.9,593.7L-158.85,908.77c-6.15,3.55-11.14.67-11.14-6.43s4.99-15.74,11.14-19.29l545.75-315.08c6.15-3.55,11.14-.67,11.14,6.43,0,7.1-4.99,15.74-11.14,19.29Z"
              />
              <path
                className="cls-2"
                d="M529.15,563.01L-16.59,878.09c-6.15,3.55-11.14.67-11.14-6.43,0-7.1,4.99-15.74,11.14-19.29l545.75-315.08c6.15-3.55,11.14-.67,11.14,6.43s-4.99,15.74-11.14,19.29Z"
              />
              <path
                className="cls-25"
                d="M215.18,513.59c-2.11-4.22-6.66-4.67-10.9-1.52-4.11-6.63-12.64-6.07-19.7,1.49-5.31-4.91-13.76-3.72-21.16,3.45-5.65-5.32-14.9-3.69-22.64,4.79-6.64,7.26-10.35,17.54-10.19,26.36-3.12.46-6.48,2.32-9.56,5.55-4.37-4.18-11.56-2.94-17.58,3.65-3.95,4.32-6.55,10.01-7.5,15.51-2.1.53-4.3,1.88-6.32,4.08-4.01,4.4-6.08,10.77-5.54,15.92l13.18-7.61,7.66-4.42,7.92-4.57,11.5-6.64,9.6-5.54,2.69-1.55,5.32-3.07,11.37-6.56,11.86-6.85,6.38-3.68,5.2-3,12.63-7.29,7.51-4.34,9.63-5.56,9.53-5.5c-.17-1.1-.43-2.16-.89-3.07Z"
              />
              <path
                className="cls-30"
                d="M54.4,627.13c-.94-4.45-2.16-8.69-3.21-13.04-.15-.65-.92-2.14-.72-3.02,0,0-5.28,23.85-5.27,34.67,0,10.83,2.36,13.63,5.27,11.95,4.3-2.48,4.96-9.11,5.26-12.92.52-6.57-.19-12.26-1.32-17.64Z"
              />
              <path
                className="cls-30"
                d="M30.63,654.93c-4.21.87-8.53,2.12-12.77,3.14-.63.15-2.46,1.01-2.94.7,0,0,12.97,8.19,21.09,8.92,8.11.73,12.42-2.04,13.88-5.79,2.15-5.55-2.2-6.81-4.78-7.44-4.44-1.09-9.37-.58-14.47.47Z"
              />
              <path
                className="cls-30"
                d="M26.77,687.47c-3.28,5.32-6.37,10.8-9.57,16.18-.47.8-1.54,3.15-2.22,3.73,0,0,18.24-15.66,26.36-25.76,8.12-10.1,10.06-15.67,8.61-17.74-2.15-3.06-7.16,2.3-10.04,5.48-4.96,5.48-9.18,11.68-13.14,18.11Z"
              />
              <path
                className="cls-30"
                d="M48.64,694.9c.93,4.45,2.16,8.69,3.21,13.04.15.65.93,2.14.73,3.02,0,0,5.27-23.85,5.28-34.67,0-10.82-2.36-13.63-5.28-11.95-4.31,2.49-4.96,9.11-5.26,12.92-.52,6.56.2,12.26,1.33,17.64Z"
              />
              <path
                className="cls-30"
                d="M72.23,668.21c4.21-.87,8.53-2.11,12.77-3.13.63-.15,2.46-1.01,2.94-.71,0,0-12.97-8.19-21.08-8.91-8.12-.73-12.43,2.04-13.89,5.79-2.15,5.55,2.21,6.81,4.79,7.44,4.43,1.09,9.37.58,14.46-.47Z"
              />
              <path
                className="cls-30"
                d="M76.15,634.32c3.27-5.32,6.37-10.81,9.56-16.18.48-.8,1.54-3.15,2.22-3.73,0,0-18.24,15.66-26.36,25.76-8.12,10.1-10.06,15.67-8.61,17.74,2.16,3.06,7.16-2.3,10.05-5.48,4.96-5.48,9.18-11.67,13.14-18.11Z"
              />
              <path
                className="cls-51"
                d="M74.31,647.05l5.35-7.84s2.8-1.27,4.17-1.86c-.55,1.49-1.83,4.44-1.83,4.44,0,0,3.32-3.8,4.94-5.75,5.06-2.08,8.9-3.43,8.9-3.43,0,0-17.46,18.06-26.79,24.44-9.33,6.39-13.15,6.26-13.41,3.06-.27-3.19,3.11-8.24,12.44-14.63,2.07-1.42,4.59-2.84,7.26-4.2-.35,1.92-1.03,5.75-1.03,5.75Z"
              />
              <path
                className="cls-9"
                d="M94.97,633.51c-3.65,3.72-17.83,18.02-25.91,23.55-9.06,6.2-12.92,6.26-13.38,3.34l39.29-26.89Z"
              />
              <polygon className="cls-23" points="53.47 669.45 53.47 780.2 49.42 782.54 49.42 671.79 53.47 669.45" />
              <polygon className="cls-35" points="50.54 671.14 49.42 671.79 49.42 782.54 50.55 781.89 50.54 671.14" />
              <polygon className="cls-13" points="53.47 682.45 53.47 687.13 49.42 689.47 49.42 684.79 53.47 682.45" />
              <path
                className="cls-23"
                d="M57.28,664.07c0,3.33-2.34,7.37-5.21,9.03l-1.25.72c-2.88,1.66-5.21.32-5.22-3.01v-6.42c0-3.32,2.34-7.37,5.22-9.03l1.25-.72c2.88-1.66,5.21-.31,5.21,3.01v6.42Z"
              />
              <path
                className="cls-35"
                d="M48.6,662.11c.1.06.1.25,0,.42l-2.81,4.88c-.1.18-.27.27-.37.21l-2.81-1.63c-.1-.06-.1-.25,0-.43l2.81-4.88c.1-.18.27-.27.37-.21l2.82,1.63Z"
              />
              <path
                className="cls-35"
                d="M56.47,657.57c.1.06.1.25,0,.43l-2.82,4.88c-.1.18-.27.27-.37.21l-2.81-1.63c-.1-.06-.1-.25,0-.43l2.81-4.87c.1-.18.27-.27.37-.21l2.82,1.62Z"
              />
              <path
                className="cls-35"
                d="M52.42,667.01c.1.06.1.25,0,.43l-2.82,4.87c-.1.18-.27.27-.37.21l-2.81-1.63c-.1-.06-.1-.25,0-.43l2.81-4.88c.1-.18.27-.27.37-.21l2.82,1.62Z"
              />
              <path
                className="cls-51"
                d="M63.98,630.6l6.02-6.99s.94-3.62,1.37-5.37c-1.16.73-3.43,2.42-3.43,2.42,0,0,2.9-4.32,4.39-6.44,1.53-6.52,2.52-11.45,2.52-11.45,0,0-13.78,22.68-18.6,34.74-4.81,12.06-4.65,16.94-2.15,17.23,2.5.28,6.38-4.13,11.19-16.2,1.07-2.68,2.14-5.93,3.15-9.38-1.49.48-4.48,1.43-4.48,1.43Z"
              />
              <path
                className="cls-9"
                d="M74.18,603.91c-2.84,4.73-13.74,23.15-17.91,33.61-4.67,11.71-4.65,16.65-2.37,17.19l20.28-50.8Z"
              />
              <path
                className="cls-51"
                d="M39.03,644.24l.38-8s-1.84-1.42-2.75-2.07c-.53,1.49-1.38,4.45-1.38,4.45,0,0-.53-3.92-.73-5.93-3.46-2.35-6.24-3.91-6.24-3.91,0,0,4.14,18.75,8.7,25.57,4.55,6.83,8.38,6.94,10.92,3.84,2.54-3.1,2.85-8.25-1.71-15.08-1.01-1.52-2.46-3.07-4.09-4.56-1.03,1.89-3.11,5.69-3.11,5.69Z"
              />
              <path
                className="cls-9"
                d="M28.52,629.71c.9,3.86,4.55,18.73,8.49,24.64,4.42,6.63,8.15,6.93,10.69,4.11l-19.18-28.75Z"
              />
              <polygon className="cls-61" points="33.49 684.24 33.49 708.13 -77.2 772.03 -77.2 748.14 33.49 684.24" />
              <path
                className="cls-30"
                d="M240.18,524.33c-1.97-3.32-4.21-6.37-6.28-9.57-.31-.48-1.46-1.42-1.44-2.22,0,0-.48,21.54,1.88,30.45,2.35,8.91,5.5,10.36,8.26,7.92,4.08-3.6,3.35-9.29,2.84-12.54-.87-5.59-2.88-10.02-5.26-14.04Z"
              />
              <path
                className="cls-30"
                d="M220.7,555.82c-4.33,2.25-8.7,4.83-13.04,7.21-.64.35-2.43,1.72-3.01,1.64,0,0,15.71,2.05,24.59-.3,8.88-2.34,12.9-6.18,13.65-9.8,1.11-5.35-3.85-4.81-6.76-4.39-5.01.71-10.19,2.92-15.44,5.63Z"
              />
              <path
                className="cls-30"
                d="M265.12,522.35c2.36-5.56,4.5-11.2,6.75-16.78.33-.82.97-3.15,1.57-3.87,0,0-16.19,19.5-22.71,30.75-6.53,11.26-7.41,16.55-5.39,17.72,2.98,1.74,7.19-4.49,9.6-8.15,4.14-6.3,7.32-12.94,10.18-19.68Z"
              />
              <path
                className="cls-51"
                d="M265.9,533.5l4.04-8.39s2.74-2.06,4.07-3.03c-.27,1.42-1,4.32-1,4.32,0,0,2.74-4.33,4.06-6.52,4.98-3.54,8.81-6.05,8.81-6.05,0,0-14.82,21.19-23.46,29.83-8.64,8.63-12.76,9.91-13.74,7.38-.98-2.53,1.54-7.91,10.19-16.55,1.92-1.92,4.32-4,6.89-6.09.04,1.71.14,5.11.14,5.11Z"
              />
              <path
                className="cls-9"
                d="M285.15,514.88c-3.11,4.39-15.23,21.29-22.72,28.77-8.38,8.38-12.51,9.83-13.65,7.6l36.36-36.37Z"
              />
              <polygon
                className="cls-23"
                points="247.11 562.21 247.11 668.41 243.23 670.65 243.22 564.45 247.11 562.21"
              />
              <polygon
                className="cls-35"
                points="244.3 563.82 243.22 564.45 243.23 670.65 244.31 670.03 244.3 563.82"
              />
              <polygon
                className="cls-13"
                points="247.11 574.67 247.11 579.16 243.22 581.4 243.22 576.91 247.11 574.67"
              />
              <polygon
                className="cls-13"
                points="247.11 585.64 247.11 590.13 243.22 592.37 243.22 587.88 247.11 585.64"
              />
              <polygon
                className="cls-13"
                points="247.11 610.81 247.11 615.31 243.22 617.55 243.22 613.06 247.11 610.81"
              />
              <polygon
                className="cls-13"
                points="247.11 648.73 247.11 653.22 243.22 655.46 243.22 650.98 247.11 648.73"
              />
              <polygon
                className="cls-13"
                points="247.11 655.46 247.11 659.95 243.22 662.2 243.22 657.71 247.11 655.46"
              />
              <polygon
                className="cls-13"
                points="247.11 661.94 247.11 666.43 243.22 668.68 243.22 664.19 247.11 661.94"
              />
              <path
                className="cls-23"
                d="M250.76,557.05c0,3.19-2.24,7.06-4.99,8.66l-1.2.69c-2.76,1.59-5,.3-5-2.89v-6.16c0-3.19,2.24-7.06,5-8.66l1.2-.69c2.76-1.59,4.99-.3,4.99,2.89v6.16Z"
              />
              <path
                className="cls-35"
                d="M242.44,555.17c.1.05.1.24,0,.41l-2.7,4.68c-.1.17-.26.26-.35.2l-2.7-1.56c-.1-.05-.1-.24,0-.41l2.7-4.67c.1-.17.25-.26.35-.2l2.7,1.56Z"
              />
              <path
                className="cls-35"
                d="M249.99,550.81c.1.06.1.24,0,.41l-2.7,4.68c-.1.17-.26.26-.36.21l-2.7-1.56c-.1-.05-.1-.24,0-.41l2.7-4.68c.1-.17.26-.26.36-.21l2.7,1.56Z"
              />
              <path
                className="cls-35"
                d="M246.1,559.87c.1.06.1.24,0,.41l-2.7,4.68c-.1.17-.26.26-.36.21l-2.7-1.56c-.1-.06-.1-.23,0-.41l2.7-4.68c.1-.17.26-.26.36-.2l2.7,1.56Z"
              />
              <path
                className="cls-51"
                d="M251.23,523.71l4.95-7.94s.22-3.32.3-4.92c-1.08,1.02-3.16,3.24-3.16,3.24,0,0,2.19-4.61,3.32-6.89.23-5.92.21-10.34.21-10.34,0,0-9.87,23.66-12.42,35.34-2.55,11.68-1.31,15.63,1.44,14.96,2.74-.67,5.95-5.72,8.5-17.39.57-2.6,1-5.66,1.34-8.86-1.49.94-4.49,2.79-4.49,2.79Z"
              />
              <path
                className="cls-9"
                d="M256.38,498.04c-2.02,4.93-9.73,24.04-11.93,34.16-2.48,11.33-1.38,15.39,1.2,15.01l10.73-49.17Z"
              />
              <path
                className="cls-51"
                d="M227.4,543.98l-1.34-6.72s-2.28-.5-3.4-.71c-.24,1.42-.51,4.16-.51,4.16,0,0-1.42-3.03-2.07-4.61-4.23-.68-7.56-.96-7.56-.96,0,0,8.53,13.92,14.91,17.89,6.38,3.97,10.51,2.68,12.57-.8,2.06-3.48,1.27-7.83-5.11-11.8-1.42-.88-3.31-1.63-5.39-2.27-.69,1.93-2.1,5.8-2.1,5.8Z"
              />
              <path
                className="cls-9"
                d="M212.95,535.83c1.81,2.85,8.96,13.77,14.48,17.21,6.19,3.85,10.26,2.75,12.38-.5l-26.86-16.71Z"
              />
              <polygon
                className="cls-61"
                points="227.92 571.99 227.92 595.88 117.22 659.79 117.22 635.89 227.92 571.99"
              />
              <polygon
                className="cls-33"
                points="233.29 670.47 114.43 739.1 114.43 675.97 233.29 607.34 233.29 670.47"
              />
              <polygon className="cls-13" points="235.7 605.95 111.28 677.78 111.28 673.52 235.7 601.69 235.7 605.95" />
              <polygon
                className="cls-13"
                points="224.01 673.71 151.49 715.57 151.49 667.97 224.01 626.1 224.01 673.71"
              />
              <polygon
                className="cls-14"
                points="199.84 643.4 199.84 688.62 154.19 714.97 154.19 669.76 199.84 643.4"
              />
              <polygon
                className="cls-18"
                points="221.3 631.01 199.84 643.4 199.84 688.62 199.84 689.79 221.97 677.01 221.97 630.62 221.3 631.01"
              />
              <polygon className="cls-44" points="163.49 664.39 154.19 680.49 154.19 669.76 163.49 664.39" />
              <polygon
                className="cls-52"
                points="175.38 657.52 154.19 694.22 154.19 683.52 166.1 662.88 175.38 657.52"
              />
              <polygon
                className="cls-48"
                points="199.84 643.4 199.84 651.01 167.27 707.42 154.19 714.97 154.19 712.35 191.07 648.46 199.84 643.4"
              />
              <polygon className="cls-56" points="199.84 653.69 199.84 657.86 173.2 704 169.6 706.07 199.84 653.69" />
              <polygon
                className="cls-13"
                points="200.95 687.98 198.83 689.2 198.83 642.58 200.95 641.36 200.95 687.98"
              />
              <polygon
                className="cls-50"
                points="237.53 585.96 108.6 660.39 108.6 675.07 237.53 600.64 237.53 585.96"
              />
              <polygon className="cls-13" points="145.9 693 112.23 712.44 112.23 690.62 145.9 671.18 145.9 693" />
              <polygon
                className="cls-24"
                points="143.54 675.16 143.54 691.73 114.58 708.45 114.58 691.88 143.54 675.16"
              />
              <polygon className="cls-3" points="124.76 686.01 114.58 703.64 114.58 691.88 124.76 686.01" />
              <polygon
                className="cls-34"
                points="128.84 683.65 114.58 708.34 114.58 705.78 126.61 684.94 128.84 683.65"
              />
              <polygon
                className="cls-38"
                points="143.54 675.16 143.54 681.51 134.68 696.85 120.05 705.3 134.4 680.44 143.54 675.16"
              />
              <polygon
                className="cls-49"
                points="233.3 607.34 233.3 610.07 180.98 700.67 114.43 739.09 114.43 675.97 233.3 607.34"
              />
              <polygon
                className="cls-13"
                points="233.1 672.71 233.11 683.28 146.79 733.12 146.79 722.54 233.1 672.71"
              />
              <polygon
                className="cls-40"
                points="211.92 684.94 211.92 695.51 210.91 696.1 210.91 685.52 211.92 684.94"
              />
              <polygon
                className="cls-40"
                points="217.96 681.45 217.96 692.02 216.96 692.61 216.96 682.03 217.96 681.45"
              />
              <polygon className="cls-40" points="224.01 677.96 224.01 688.53 223 689.12 223 678.54 224.01 677.96" />
              <polygon
                className="cls-40"
                points="230.04 674.48 230.05 685.05 229.04 685.63 229.04 675.06 230.04 674.48"
              />
              <polygon className="cls-15" points="235.7 673.35 146.78 724.68 146.78 720.42 235.7 669.08 235.7 673.35" />
              <polygon className="cls-15" points="235.7 684.99 146.78 736.33 146.78 733.12 235.7 681.79 235.7 684.99" />
              <polygon className="cls-40" points="235.7 670.15 146.78 721.49 146.78 720.42 235.7 669.08 235.7 670.15" />
              <polygon className="cls-40" points="220.3 678.51 217.08 680.36 217.08 616.7 220.3 614.84 220.3 678.51" />
              <polygon
                className="cls-40"
                points="177.41 703.27 174.19 705.12 174.19 641.46 177.41 639.61 177.41 703.27"
              />
              <polygon className="cls-21" points="235.7 652.8 146.78 704.13 146.78 699.87 235.7 648.54 235.7 652.8" />
              <polygon className="cls-21" points="235.7 669.08 146.78 720.42 146.78 716.16 235.7 664.83 235.7 669.08" />
              <polygon
                className="cls-21"
                points="191.45 693.46 187.75 695.6 187.75 678.35 191.45 676.22 191.45 693.46"
              />
              <polygon
                className="cls-21"
                points="206.75 684.62 203.06 686.76 203.06 669.51 206.75 667.38 206.75 684.62"
              />
              <polygon
                className="cls-40"
                points="111.28 677.78 114.43 675.97 114.43 718.55 111.28 720.37 111.28 677.78"
              />
              <polygon
                className="cls-23"
                points="227.92 574.9 227.92 576.07 117.22 639.97 117.22 638.81 227.92 574.9"
              />
              <polygon
                className="cls-23"
                points="227.92 578.98 227.92 580.15 117.22 644.05 117.22 642.89 227.92 578.98"
              />
              <polygon
                className="cls-23"
                points="227.92 583.06 227.92 584.23 117.22 648.13 117.22 646.97 227.92 583.06"
              />
              <polygon
                className="cls-23"
                points="227.92 587.14 227.92 588.3 117.22 652.21 117.22 651.05 227.92 587.14"
              />
              <path
                className="cls-30"
                d="M271.89,683.22c-.28.52-.57,1.01-.87,1.5-4.22,6.93-10.4,11-14.28,9.2-4.14-1.92-4.09-9.83.13-17.67,4.22-7.84,10.99-12.63,15.14-10.71,1.68.78,2.67,2.55,2.97,4.9.18,1.41.11,3.03-.21,4.77-.23,1.31-.61,2.69-1.13,4.1-.47,1.28-1.05,2.59-1.76,3.9Z"
              />
              <path
                className="cls-47"
                d="M271.66,665.42c-4.17-1.51-10.68,3.21-14.78,10.83-4.1,7.62-4.26,15.3-.45,17.48l15.23-28.31Z"
              />
              <path
                className="cls-9"
                d="M264.58,677.15c.41-.75,1.1-1.2,1.55-.99h0c.45.21.49.99.08,1.74l-11.1,20.63c-.41.75-1.1,1.2-1.55.99h0c-.45-.21-.49-.99-.08-1.74l11.1-20.63Z"
              />
              <path
                className="cls-51"
                d="M274.79,675.22l-6.42,1.67c-.3.08-.57.05-.78-.05-.54-.25-.79-.98-.6-1.95.3-1.38,1.39-2.73,2.43-2.99l5.57-1.46c.18,1.41.11,3.03-.21,4.77Z"
              />
              <path
                className="cls-51"
                d="M271.89,683.22c-.28.52-.57,1.01-.87,1.5l-7.98,2.07c-.3.08-.58.07-.8-.04-.53-.24-.77-.99-.58-1.96.29-1.38,1.37-2.71,2.43-2.99l9.56-2.49c-.47,1.28-1.05,2.59-1.76,3.9Z"
              />
              <path
                className="cls-30"
                d="M258.74,675.36c0,.48-.03.97-.07,1.46-.53,6.91-4.82,14.54-10.05,17.55-5.57,3.22-10.1-.07-10.1-7.34s4.53-15.78,10.1-19c2.27-1.31,4.36-1.54,6.05-.87,1.01.4,1.88,1.13,2.55,2.15.51.76.9,1.69,1.16,2.77.24.97.37,2.07.37,3.29Z"
              />
              <path
                className="cls-47"
                d="M248.18,668.32c-5.37,3.41-9.65,11.63-9.65,18.71s4.28,10.36,9.65,7.57v-26.28Z"
              />
              <path
                className="cls-9"
                d="M247.34,679.96c0-.7.49-1.55,1.1-1.9h0c.61-.35,1.1-.07,1.1.63v19.14c0,.7-.49,1.55-1.1,1.9h0c-.61.35-1.1.07-1.1-.63v-19.14Z"
              />
              <path
                className="cls-51"
                d="M257.22,669.3l-5.94,6.88c-.28.32-.59.57-.88.74-.72.42-1.42.37-1.78-.22-.48-.85-.09-2.45.89-3.57l5.16-5.98c1.01.4,1.88,1.13,2.55,2.15Z"
              />
              <path
                className="cls-51"
                d="M258.74,675.36c0,.48-.03.97-.07,1.46l-7.4,8.56c-.28.32-.58.58-.89.76-.71.41-1.41.34-1.76-.24-.48-.85-.09-2.44.89-3.57l8.86-10.25c.24.97.37,2.07.37,3.29Z"
              />
              <path
                className="cls-30"
                d="M239.6,686.35c.31.15.59.33.85.53,3.82,2.74,4.15,9.69.59,16.16-3.8,6.9-10.63,10.64-15.23,8.34-4.61-2.3-5.26-9.77-1.46-16.67,1.55-2.81,3.6-5.09,5.79-6.66,1.31-.95,2.68-1.62,4.02-2.01,1.01-.29,2.01-.42,2.96-.34.87.06,1.7.26,2.47.65Z"
              />
              <path
                className="cls-51"
                d="M234.17,686.03l-1.87,8.45c-.09.4-.25.8-.45,1.16-.49.89-1.26,1.61-2,1.8-1.04.24-1.65-.68-1.33-2.07l1.62-7.33c1.31-.95,2.68-1.62,4.02-2.01Z"
              />
              <path
                className="cls-51"
                d="M239.6,686.35c.31.15.59.33.85.53l-2.33,10.52c-.09.4-.24.8-.45,1.18-.48.88-1.25,1.59-2,1.78-1.04.24-1.63-.68-1.33-2.07l2.79-12.59c.87.06,1.7.26,2.47.65Z"
              />
            </g>
          </g>
          <path
            className="cls-55"
            d="M594.38,216.55c1.12.09,2.45.33,3.24,1.31,2.2,2.24,5.02-.18,7.65.45,3.81,1,3.08,3.85,8.33,1.77,1.62-.5,2.6.96,3.9,1.5,8.44-.36,14.76,7.58,20.76,12.68,1.81,2.19.54,5.71,2.81,7.75,2.42,40.37.19,82.53.93,123.48.13,1.41-1.57,2.04-1.85,3.24-.45,1.4-.21,2.93-.25,4.4.6,26.83-1.27,54.07.72,80.7-.07,11.63-.13,23.26-.21,34.89-.26,1.52-1.89,2.37-1.52,4.11.04,18.38.13,36.77.17,55.15.06,6.85-4.09,12.98-6.82,19.11-.76,2.35-3.93,1.57-4.3,4.17-1.83,1.57-4.86,1.48-5.78,4.33-3.03,3.75-8.98,3.6-11.65,8.16-2.64,3.16-6.98,1.79-9.05,6.06-1.57,2.04-4.23,2.69-6.38,3.9-1.15,1.14-1.87,2.94-3.61,3.18-1.07.05-1.35,1.28-2.14,1.75-2.28.56-4.64,1.12-5.51,3.65-.47.75-1.48.56-2.21.83-2.37,1.19-3.85,4.22-6.95,3.65-5.23.28-8.66,5.25-13.7,6.33-9.98,2.44-17.93-8.04-16.92-17.39.16-120.97,1.47-241.97.86-362.95-.18-4.69,1.36-9.65,4.35-13,3.02-3.64,7.68-5.74,12.69-6.24,1.14.03,1.54-1.37,2.4-1.63,1.52.22,3.63.16,4.69,1.41.27.53.66,1.02,1.3,1.03,1.09.23,1.2-1.34,2.12-1.41,4.57.19,8.75,3.3,13.51,2.23,3.03-.75,5.29,2.25,8.25,1.38h.17ZM550.89,570.71c1.09,12.28-2.17,26,1.38,37.62,7.03,4.56,16.71-2.25,15.53-10.58,1.18-105.76,1.85-211.6,4.3-317.4-1.42-17.13,3.1-35.98-2.75-52.21-4.37-8.33-14.09-8.74-19.44-.5-6.29,12.71-1.49,28.42-2.74,42.23,2.5,100.17.68,200.47,3.71,300.67v.17ZM594.92,311.65c-3.3-.1-6.72.15-10.02.42-1.03.14-2.44.09-3.1,1.02-.38.56-.27,1.57.17,2,.56.58,1.49.64,2.27.66,2.54-.04,5.09.19,7.63-.24,3.1-.71,6.32-1.66,9.03.72.76.69,1.66,1.55,2.76,1.34,1.53-.29,2.37-1.81,2.22-3.27.02-1.67-1.16-2.64-2.78-2.56-2.67-.08-5.39.06-8.04-.06l-.14-.02ZM601.84,372.43c2.52.83,4.41-1.67,3.24-3.83-3.13-2.72-17.66,1.5-22.04,2.17-1.41.12-2.45,1.37-1.25,2.52,6.54,1.42,13.26-2.88,19.87-.91l.18.04Z"
          />
          <path
            className="cls-31"
            d="M145,222.35c2.29-.77,4.55.71,6.86.49,1.56.03,2.92-.69,4.4-1.05,1.45-.19,2.92-.23,4.38-.35,8.32-.81,16.7.49,25,.19,1.97.06,4.08.71,5.94-.28,1.01-.71,2.07-1.34,3.35-1.34,3.88-.38,7.81-.29,11.7-.11.76.13,1.44.64,2.18.78.94.2,1.88.08,2.83-.03,7.21-.98,14.57-.86,21.85-1.05,1.23-.09,2.3-1.05,3.61-1.06,6.45-.67,12.94-.94,19.41-.58,1.28.25,2.42.98,3.76.82,9.08-1.19,18.24-2.11,27.45-2.22,1.74-.12,3.43.63,5.14.63,6.64-1.78,13.66.75,20.36-1.34,1.63-.45,3.19-.21,4.73.32.58-.02,1.03-.46,1.63-.54,2.11-.06,4.31-.17,6.42.05,1.79.57,3.59,1.24,5.39,1.11,1.9.03,3.6-.95,5.38-1.46,6.1-1.24,12.3-.48,18.45-.68,2.03.08,4.05,1.38,6.01,1.15.85-.05,1.68-.3,2.48-.84.73-.55,1.44-1.19,2.35-1.19,8.81-.13,17.64-.19,26.45-.35,1.88.03,3.79.39,5.67.34,2.05.22,3.87-1.3,5.87-1.62,3.37-.06,6.74-.25,10.11-.22,10.06,1.55,20.12.47,30.04-1.36,3.32-.16,6.65-.26,9.97-.33,4.92.75,9.87.4,14.81.31,1.36-.06,2.67.31,4.01.12,1.14-.09,1.91-1.49,3.1-1.49,5.3-.12,10.6-.22,15.9-.34,1.26-.11,2.34.82,3.58.79,8.78-.67,17.63-1.02,26.44-1.19.95-.16,1.76-.91,2.82-1.03,4.7-.62,9.5-.35,14.18.17.9-.02,1.77-.51,2.68-.46,1.41.12,2.93.04,4.1.97,1.06.7,2.4.44,3.61.65.66.09,1.54.43,1.38,1.2-.71,1.54-2.5,2.29-3.89,3.15-4.03,2.47-8.2,5-10.36,9.27-4.31,7.61-10.43,7.82-18.08,7.5-6.95.6-1.05,9.16-3.01,13.23-.2.5-.62.89-1.19.84-1.01-.14-2.45-.08-3.25-.78-.46-.4-.89-.71-1.52-.78-4.56-.53-9.16-.52-13.75-.49-10.07.23-20.18-.06-30.26,0-.82.04-1.55.31-2.07,1.03-.42.52-.93.85-1.61.84-133.82,2.15-267.68,6.83-401.5,9.2-2.23-.03-4.41.67-5.27,3.03-.27.58-.76,1.07-1.24,1.48-1.38,1.13-.83,2.91-.91,4.47-.03.2-.05.54-.22.65-.08.06-.19.06-.32,0-3.39-2.51-4.92-7.05-5.34-11.16-.89-6.74.96-13.14.85-19.74.07-3.25,4.08-4.52,6.87-4,1.37.18,2.06-1.21,3.38-1.33.6-.08,1.16-.23,1.76-.16.78.07,1.57.62,2.37.51.98-.06,1.49-1.44,2.49-1.56,15.71-1.29,31.58-.61,47.23-.25,1.3-.02,2.29-.99,3.41-1.5,1.46-.46,3.02-.47,4.54-.52,8.39-.55,16.85,2.9,24.97-.47l.17-.05Z"
          />
          <path
            className="cls-31"
            d="M515.11,243.73c1.81-3.82-1.45-9.06.19-12.51,5.69-4.54,13.93,3.15,21.07-8.93,2.66-5.25,8.33-7.74,13.04-10.87,1.03-1.09,2-1.99,3.6-2.05,1.18-.55,2.47-.59,3.47.42,1.44,2.27,10.27-1.43,6.51,3.3-10.03,1.21-18.39,8.34-18.07,18.83.62,121.51-.74,243.07-.85,364.57-1.03,10.46,9.97,21.12,20.04,15.41,3.09-1.48,5.63-4.12,9.01-4.92.95-.23.82.98.73,1.88-.08.6-.62.98-1.22,1.08-3.51.65-5.9,2.83-7.73,5.73-.65.59-1.91.08-2.47.91-1.92,2.93-5.56,3.87-8.31,5.71-1.54.62-2.96-.47-4.44-.84-9.78-2.5-18.7-7.96-28.84-8.94-19.03-1.94-37.71-6.86-56.62-9.91-22.84-3.28-45.33-8.13-68.1-11.84-2.66-.1-4.74-3.88-.55-3.41,32.91,2.68,65.68,6.22,98.53,9.48,3.39.62,5.72-1.01,8.33-2.98,2.94-.35,6.13.24,8.17-2.24,3.04-1.65,4.84-4.07,4.41-7.78,1.12-84.74,1.51-169.46,2.7-254.2.84-25.13.14-50.27.21-75.41.22-3.71-.92-7.23-2.81-10.32l-.02-.16Z"
          />
          <path
            className="cls-31"
            d="M501.53,593.99c-2.32,4-7.6,2.67-11.43,2.35-31.75-3.11-63.4-6.61-95.21-9.11-1.64-.16-1.94,1.38-1.08,2.41.57.67,1.58.88,2.44,1.05,10.34,1.91,20.65,3.61,31,5.38,14.23,2.9,28.57,5.3,42.95,7.45,16.94,3.14,33.8,7.18,50.9,8.96,8.17.69,15.37,4.72,23.1,7.19,2.06.7,4.23,1.24,6.23,2.01.7.33.73,1.46.04,1.82-.84.33-1.86.45-2.78.43-1.97-.14-4-.83-5.78.28-.64.42-1.35.86-2.14.79-.58-.03-1.14-.3-1.65-.6-2.97-1.81-6.26-.13-9.45-.51-.91-.1-1.88-.07-2.75-.34-1.47-.6-2.86-1.59-4.49-1.74-1.5-.29-3.03.64-4.5.4-1.24-.17-2.5-.12-3.59-.87-.3-.16-.57-.34-.89-.44-1.56-.57-3.17-.03-4.76,0-2.23-.09-4.48-.35-6.71-.53-.97-.06-1.59-.99-2.35-1.4-1.58-.78-3.26.35-4.98.14-.84-.09-1.69-.12-2.51-.31-2.44-.95-4.76-2.24-7.49-1.44-1.55.3-3.13-.09-4.68-.19-.8-.08-1.36-.66-2-1.09-.61-.35-1.27-.34-1.96-.27-1.83.21-3.7.37-5.49-.06-2.91-.97-5.89-1.69-8.93-2.11-.78-.12-.87-1.36-1.59-1.39-.36.03-.91.31-1.31.42-.89.18-1.83.01-2.74.02-1.6-.17-3.51.32-4.75-.98-2.39-2.25-5.5-.89-8.43-.94-2.32.31-3.79-1.98-5.98-2.38-3.41-1.02-7.05-.67-10.48-1.37-11.86-2.07-24.07-2.66-36.03-4.57-1.9-.13-3.83.09-5.67.82-1.4.36-3.09.26-4.27-.65-2.47-2.14-5.21-2.44-8.17-1.39-1.07.45-2.25.49-3.38.34-1.19-.17-1.83-1.67-2.96-1.88-1.11-.32-2.31.02-3.41.33-1.34.51-2.81.17-4.26.03-.67-.06-1.28-.32-1.8-.76-1.9-1.74-4.02-2.07-6.35-1.13-1.33.59-2.84.35-4.23.25-.92-.1-1.27-1.29-2.13-1.67-6.96-2.19-14.46-2.16-21.47-4.5-5.9-1.32-12.04-.52-18.02-1.24-3.79-.44-7.6-2.44-11.43-1.11-.91.35-1.83.86-2.74.72-.66-.06-1.03-.44-1.24-1.04-.28-.89-.99-1.39-1.87-1.56-5.58-1.21-11.21-2.26-16.88-.67-1.13.3-2.53.47-3.34-.54-1.91-2.98-5.57-3.03-8.73-2.92-10.61.08-20.6-3.86-31.06-4.75-3.15-.32-6.42.16-9.53-.17-2.43-.27-4.83-1.35-7.31-1.71-5.67-1.05-11.49-.96-17.2-1.77-3.85-.37-7.47-1.99-11.2-2.67-10.9-1.04-21.71-2.75-32.53-4.59-23.95-3.56-47.86-7.41-71.85-10.65-6.05-.8-12.33-.64-18.12-2.79-3.45-1.39-6.74-5.72-7.77-9.74-.63-2.14-.34-4.19.54-6.18.29-.54.73-.96,1.37-1,1.1-.01,2.03.82,2.96,1.37,6.07,3.87,13.46,3.61,20.36,4.2,15.87,1.61,31.75,3.54,47.51,6.04,2.76.26,5.54.15,8.33-.64,1.74-.19,4.04-.71,5.38.71,2.21,2.37,4.03,1.51,6.1-.56.4-.26.84-.32,1.3-.28,4.73.37,9.48.61,14.19,1.18,26.41,3.57,52.82,7.42,79.35,10.1,63.54,8.5,127.24,16.04,190.79,24.7,24.32,2.93,48.91,5.45,73.01,9.2l.02.09Z"
          />
          <path
            className="cls-31"
            d="M131.82,548.72c-5.85,2.38-12.49.18-18.47-.63-12.61-1.74-25.33-3.22-37.98-4.52-7.31-.59-14.97-.37-21.25-4.87-2.77-2.13-4.04,1.14-4.13,3.73.51,14.24,15.64,14.45,26.45,15.31,23.96,3.25,47.84,7.08,71.76,10.63,14.63,2.78,29.41,3.59,43.8,7.26,8.24.82,16.57,1.17,24.55,3.48,13.84-.97,26.88,4.65,40.65,4.92,3.09-.04,6.64-.19,8.57,2.76.3.49.06.84-.69.78-8.42-.22-16.66-1.94-24.98-3.1-28.06-2.94-56.07-8.93-84.1-10.87-10.31,9.25-17.93,21.88-27.38,32.2-1.44,1.64-2.67,4-4.98,4.43-.82-.11-.74-1.28-1.38-1.69-4.15-1.93-8.7-1.3-4.93-7.3,4.61-7.58,9.59-14.94,14.22-22.51,1.43-2.63,6.17-5.11,3.57-8.46-2.07-2.59-6.32-.93-9.39-1.65-1.18-.52-2.02-2.02-3.49-1.86-1.89.16-4.03,1.22-5.83-.11-3.17-1.9-6.76-.25-10.18-.88-1.23-.16-2.55-.1-3.73-.43-.88-.35-1.45-1.37-2.45-1.47-2.55-.07-5.5,1.08-7.89-.47-1.01-.68-2.14-1.25-3.34-1.42-3.02-.06-6.78,1.64-9.56-.52-2.29-1.62-5.15.19-7.72-.57-6.98-4.22-8.72.19-11.99-2.28-10.92-3.01-17.97-12.86-19.03-24.16-.6-96.41-4.92-193.11-2.95-289.45,1.12-5.91,4.16-11.69,9.97-14.55,1.33,6.09-1.56,12.97-.57,19.42.37,4.84,1.8,9.02,5.42,12.3,1.26,9.98.27,20.51.69,30.68-.23,73.33,3,146.65,2.85,220,1.46,8.43-4.33,23.35,6.76,25.93,1.74,1.48,2.66.17,4.5.06,1.31.2,3.07-.37,4.02.78.51.78,1.26,1.1,2.16,1.08,3.67.08,7.37.03,11.02.28.93.21,1.47,1.55,2.28,1.74,1.46.58,2.83-1.05,4.3-.56,5.37,1.55,10.89,1.69,16.42,1.79,3.46,2.5,2.69,2.28,6.87,1.02,5.54.46,10.98,2.01,16.58,1.97.99-.18,1.54.88,1.07,1.65l-.09.11Z"
          />
          <path
            className="cls-55"
            d="M355.82,214.7c-6.3.52-12.72-.53-19,.75-2.15.25-4.2-1.03-6.39-.76-1.61-.03-3.2.59-4.81.98-2.07.13-4.17.1-6.25.03-.57-.08-1.08-.4-1.53-.43-.55,0-1.12.51-1.8.53-2.06.2-2.83-.5-3.02-2.67-.24-7.65,21.37-8.58,27.12-10.24,2.61-.74,5.93.07,7.85-2.24.71-1.12,1.3-2.13,2.33-2.91,2.46-3.02,3.21-7.14,4.88-10.62,13.29-32.46,25.74-65.27,38.89-97.79,1.13-3,2.07-6.04,2.94-9.15,1.17-2.82,3.87-4.9,7.08-4.47.09.02.27.07.37.09.51.17.54.63.3,1.19-15.3,38.18-30.38,76.44-45.87,114.42-3.33,7.78-3.14,8.51,5.42,9.52,8.91,1.23,17.57,3.35,24.74,9.22.93.73,2.99,2.95,1.08,3.47-8.59.14-17.34.24-25.94.31-2.76-.15-5.66-.61-8.23.72l-.17.05Z"
          />
          <path
            className="cls-55"
            d="M204.07,23.82c4.65-3.32,9.94-.31,13.36,3.43,2.26,2.71,2.92,6.06,2.2,9.17-.92,2.69-2.12,6.02-.9,8.47,30.83,50.5,61.81,101.04,93.49,150.95,1.5,1.51,3.2,2.39,5.39,2.53,1.33.12,2.88-.26,4.14-.18.61.05,1.29.01,1.84.25.22.13.22.37.01.62-.4.44-1.05.64-1.65.67-4.71.45-9.38-.02-13.81-1.67-1.47-.52-1.6-2.25-2.24-3.48-30.18-49.23-61.3-98.22-91.41-147.55-2.56-3.64-5.45-7.05-8.91-10.07-3.47-2.93-2-8.02-1.87-11.97.04-.4.08-.86.35-1.17Z"
          />
          <path
            className="cls-4"
            d="M439.97,610.83c1-.17,2.38-.26,3.36.23,2.14,1.29,4.47,1.7,6.95,1.49,2.27-.08,4.55.11,6.81.17.81.02,1.35.63,2.08.79,3.56.25,7.02,1.06,10.38,2.2.85.28.56,1.13.46,1.84-.51,3.9.73,7.73,1.36,11.54,1.05,8.59,2.5,17.16,3.68,25.73.17,1.78.71,4.46-.66,5.69-1.34,1.03-3.53.91-5.3.96-2.29.01-4.82,0-7.03.02-6.35.14-7.63-.41-9.53-6.68-4.7-14.07-9.5-28.11-14.27-42.16-.16-.45-.15-.91.42-1.07.45-.14.76-.47,1.14-.69l.14-.06ZM470.99,654.88c.04-.95.07-2.11-.35-3.03-3.66-9.41-6.03-19.46-10.91-28.34-.39-.48-1.17-.48-1.79-.06-.99.64-.87,1.76-.7,2.76,1.78,9.77,4.5,19.26,5.88,29.09.44,2.92,2.83,4.86,6.02,4.27,2.37-.35,1.7-2.77,1.84-4.52v-.16Z"
          />
          <path
            className="cls-8"
            d="M203.69,23.98c.42,4.05-1.82,9.51,1.82,12.72,3.41,2.98,6.28,6.32,8.82,9.9,30.03,48.81,60.17,97.68,90.59,146.17.73,1.27,1.24,2.64,1.79,4,.58,1.11-.1,2.26-1.09,2.8-.93.61-2.44-.06-2.83-1.17-1.82-3.64-3.81-7.18-5.9-10.65-28.33-45.18-55.9-90.83-83.9-136.24-1.49-2.54-3.63-4.55-6.47-5.5-2.78-.7-5.59-1.52-7.28-3.97-4.4-5.75-3.59-16.43,4.37-18.1l.09.05Z"
          />
          <path
            className="cls-8"
            d="M303.25,199.38c1.06.31,2.14.35,2.9-.6.34-.39.65-.88,1.08-.91,4.92,1.52,10.16,2.53,15.32,1.68.74-.12,1.18-.96,1.88-1.24,2.89-.55,5.96-.6,8.88-.04,4.07,1.72,8.18,2.12,12.34,1.06.89-.04,3.4-1.28,3.34-.02-1.11,3.67-5.58,2.75-8.56,3.54-5.66,1.75-30.89,2.66-26.81,12.27.42,3.13-15.57,1.27-18.05,1.7-.53.02-1.04-.1-1.5-.37-4.94-3.01-9.06-6.76-11.22-12.29-.51-1.13.46-1.5,1.42-1.65,1.26-.26,2.75.51,3.87-.29,1.81-1.71,4.56-1.46,6.76-.88.54-.12.89-.66,1.37-.93,1.15-.79,2.4-.23,3.63-.03.97-.37,1.96-1.11,3.14-1.02l.18.02Z"
          />
          <path
            className="cls-8"
            d="M348.92,198.98c-3.1.78,2.28-10.88,2.54-12.29,14.43-36.38,28.89-72.7,43.35-109.11,1.09-2.86,1.18-5.71-.65-8.38-.97-1.48-2.05-3.05-1.84-4.94.08-.42.29-.28.47,0,2.71,4.13,6.67,8.32,3.93,13.34-.17.38-.42.85-.25,1.26.33.59.5,1.25.23,1.95-.89,3.36-2.02,6.65-3.26,9.9-14.1,34.96-27.37,70.24-41.65,105.13-.62,1.3-1.47,2.47-2.72,3.08l-.15.05Z"
          />
          <path
            className="cls-4"
            d="M126.64,568.81c3.02-.27,8.03-1.14,9.16,2.7.48,2.65-2.41,4.27-3.74,6.24-4.74,7.56-9.64,15.04-14.36,22.61-2.99,4.75-2.48,6.26,3.11,7.32,2.87.73,2.93,3.51-.3,3.5-1.23.09-2.4-.4-3.35-1.16-2.02-.15-3.89-1.47-5.28-2.82-3.26-3.02-1.76-7.25.19-10.78,4.03-7.54,8.2-14.9,12.29-22.37.99-1.62,1.84-3.32,2.19-5.17l.09-.09Z"
          />
          <path
            className="cls-55"
            d="M398.96,51.46c5.77-3.29,13.46-1.79,16.88,4.46,2.83,4.73,2.24,11.18-2.34,14.92-.99.01-1.85-.52-2.88-.83-10.54-3.46-10.75-5.68-10.73-16.48-.03-.18-.09-.54-.13-.72-.19-.46-.96-.93-.86-1.25l.05-.1Z"
          />
          <path
            className="cls-28"
            d="M282.82,203.33c2.31,5.83,6.53,10,11.9,13.11.63.49-.3.72-.79.83-1.95.36-3.84-.71-5.8-.58-8.58.16-17.12.75-25.61,1.93-1.73.23-3.75.68-5.3-.3-.13-.11-.11-.21.07-.29,3.26-.59,5.84-2.81,7.95-5.28,4.24-5.35,10.5-8.86,17.46-9.51l.12.07Z"
          />
          <path
            className="cls-55"
            d="M640.56,452.63c-1.12-1.07-.6-3.18-.69-4.64.43-26.63-.84-53.56.48-80.05.25-.61,1.64-2.02,1.67-.54,1.16,26.74-.67,53.44-.73,80.17-.08,1.64.49,3.73-.64,5.07h-.09Z"
          />
          <path
            className="cls-55"
            d="M399.88,52.67c.28,12.5-.28,13.66,13.13,18.14.83.33,0,.85-.37,1.27-1.96,1.82-4.54,2.68-6.95,3.75-.33.1-.65.17-1,.14-3.29-.57-5.64.83-7.39,3.52-.51.72-1.23-.32-.93-.88,3.36-5.74-1.05-9.98-3.79-14.34-.47-.88-.21-1.97-.19-2.94.07-.8,1.13-1.18,1.27-1.91.28-.89-.01-1.85.14-2.77.4-2.61,2.17-4.12,4.42-5.11.77-.33,1.16.55,1.6,1.01l.06.12Z"
          />
          <path
            className="cls-55"
            d="M642.16,341.21c-.15-32.18-.71-64.77.07-96.88,1.3.81,1.49,3.32,1.46,4.83-.16,29.57-.36,59.26-.57,88.87-.02,1.08,0,2.51-.91,3.2l-.06-.02Z"
          />
          <path
            className="cls-31"
            d="M440.03,610.82c-.25.91-1.63.95-2.45.8-17.69-2.41-35.39-4.89-53.08-7.31-2.77-.72-.81-1.38.7-1.7,2.35-.5,4.77-.21,7.1.18,11.03,1.9,22.38,2.15,33.31,4.22,4.74,1,10.75-.21,14.39,3.69l.02.12Z"
          />
          <path
            className="cls-31"
            d="M289.99,590.57c3.84-2.73,8.8-.1,12.98.37,6.05.73,12.25-.08,18.22,1.25,6.99,2.27,14.37,2.45,21.37,4.39.67.12,2.27,1.69.89,1.74-7.91-.94-15.91-1.66-23.78-3-9.79-1.91-20.16-1.74-29.68-4.68v-.07Z"
          />
          <path
            className="cls-55"
            d="M639.16,548.1c-.28-18.84-.26-37.88-.21-56.77-.07-.78,1.39-2.65,1.46-.95-.01,18.07-.02,36.13-.03,54.2-.02,1.21-.14,2.8-1.16,3.54l-.06-.02Z"
          />
          <path
            className="cls-31"
            d="M443.93,210.74c-9.78,1.88-19.91,2.95-29.82,1.3,9.79-1.59,19.89-2.31,29.81-1.33v.02Z"
          />
          <path
            className="cls-31"
            d="M523.91,207.78c-.54.5-1.72.99-2.57.92-7.95.05-15.89.32-23.81.99-1.31.09-2.65.35-3.9-.17-.6-.25-.81-.54-.09-.63,10.06-1.33,20.25-2.39,30.35-1.15v.05Z"
          />
          <path
            className="cls-31"
            d="M235.99,218.84c-.55.48-1.75.95-2.6.89-7.11.11-14.24.07-21.32.95-1.58.15-3.77.67-4.94-.64,9.4-1.4,19.3-2.36,28.84-1.25v.05Z"
          />
          <path
            className="cls-31"
            d="M268.04,587.59c6.12-2.12,12.45-.79,18.52.54.9.21,1.47,1.31,1.46,2.14-.03.13-.14.2-.31.21-6.54-.63-13.34-.77-19.67-2.83v-.05Z"
          />
          <path
            className="cls-55"
            d="M563.81,211.66c-.1-.21-.11-.78.21-.85.89-.08,2.03.12,2.97.17,6.58.62,13.02,2.05,19.36,3.91.42.12.37.24-.04.34-5.19,1.25-9.72-2.29-14.72-2.31-2.59,0-5.21-.52-7.69-1.18l-.08-.09Z"
          />
          <path
            className="cls-55"
            d="M638.73,234.76c-4.99-5.04-10.66-9.38-16.76-12.95,7.65,1.35,13.57,5.82,16.78,12.93l-.02.02Z"
          />
          <path
            className="cls-31"
            d="M115.09,223.59c-1.71,2.1-4.85,1.24-7.2,1.11-4.27.17-8.58,0-12.88-.14-.43,0-.41-.08,0-.2,6.58-1.95,13.4-1.36,20.07-.85v.07Z"
          />
          <path
            className="cls-31"
            d="M475.02,209.5c-.97,2.02-3.69,1.25-5.48,1.21-4.9-.05-9.83.59-14.72-.24-.42-.07-.41-.15,0-.23,6.64-1.27,13.48-1.38,20.17-.83l.03.09Z"
          />
          <path
            className="cls-31"
            d="M193.05,220.47c-1.82,2.26-5.03,1.34-7.51,1.22-3.59.23-7.2-.02-10.82-.19-.57-.07.44-.28.78-.42,5.69-1.74,11.69-.99,17.54-.68v.07Z"
          />
          <path
            className="cls-31"
            d="M145.05,222.43c-5.63,2.46-11.98,1.53-17.88.58,5.86-.68,11.95-1.68,17.88-.63v.04Z"
          />
          <path
            className="cls-55"
            d="M631.04,568.9c3.51-4.87,4.78-11.02,7.79-16.14-.37,6.15-2.16,12.5-7.77,16.16l-.02-.02Z"
          />
          <path
            className="cls-8"
            d="M348.01,196.93c.03.27.13,1.53-.05,1.78-4.41,1.46-9.56,2.14-13.91-.17,4.47-1.26,9.57.91,13.89-1.64l.07.03Z"
          />
          <path
            className="cls-31"
            d="M390.83,213.56c.03-.34-.11-1.09.03-1.41,3.52-.1,7.21.14,10.78.15.37.04,1.03-.05,1.29.07-.01.1-.42.33-.62.46-3.48,2.14-7.63.44-11.42.79l-.06-.05Z"
          />
          <path className="cls-31" d="M369.92,601.64c3.24-1.65,7.6-1.41,10,1.52-3.29.52-6.92-.22-10.01-1.47v-.05Z" />
          <path className="cls-31" d="M62.14,559.42c2.89-1.35,6.34-.6,8.81,1.3-2.87.56-6.38.73-8.82-1.23v-.07Z" />
          <path
            className="cls-55"
            d="M609.84,584.42c2.39-3.03,5.67-5.85,9.56-6.48-2.47,2.9-6,5.06-9.55,6.5l-.02-.02Z"
          />
          <path className="cls-31" d="M85.11,562.53c2.57-1.48,5.76-.58,7.86,1.32-2.56.55-5.85.83-7.87-1.24v-.08Z" />
          <path
            className="cls-31"
            d="M553.85,209.07c-.69.74-1.92.76-2.86.62-.28-.17-.52-.44-.83-.55-1.62-.77-4.27.36-5.3-1.5,1.38-.5,3.15-.52,4.64-.38,1.53.17,3.12.81,4.35,1.72v.08Z"
          />
          <path
            className="cls-31"
            d="M564.89,615.71c1.5-3.13,4.68-5.49,8.1-5.93-1.98,2.62-4.98,4.77-8.07,5.96l-.03-.03Z"
          />
          <path className="cls-31" d="M107.95,565.8c2.96.08,6.67-1.09,9.08,1.18-2.94.56-6.52.79-9.09-1.14v-.04Z" />
          <path className="cls-31" d="M529.59,623.92c3.06-.07,6.87-1.42,9.35,1.01-3.03.44-6.67.96-9.35-.97v-.04Z" />
          <path className="cls-55" d="M613.82,220.04c-2.31,1.17-5.74,1.41-6.95-1.4,2.24-.87,5.01.04,6.95,1.34v.06Z" />
          <path className="cls-31" d="M155.98,221.89c-2.68,1.42-6.01,1.3-8.79.19,2.71-1.11,5.95-.71,8.79-.23v.04Z" />
          <path className="cls-31" d="M347.97,598.53c2.58-1.52,6.11-1.22,7.95,1.31-2.58.45-5.64.12-7.95-1.24v-.06Z" />
          <path
            className="cls-55"
            d="M600.85,590.5c1.59-2.41,3.95-5.15,7.17-4.7-1.69,2.24-4.51,3.76-7.14,4.73l-.02-.03Z"
          />
          <path className="cls-31" d="M518.03,622.27c2.58-1.26,5.57-.24,7.79,1.33-2.54.69-5.51,0-7.79-1.27v-.06Z" />
          <path className="cls-31" d="M482.98,617.48c2.63-1.01,5.57-.11,7.88,1.3-2.56,1-5.56-.02-7.89-1.25v-.05Z" />
          <path
            className="cls-55"
            d="M621.82,576.29c.69-2.71,3.39-4.27,6.04-4.55-1.33,2.09-3.61,3.81-6,4.6l-.04-.05Z"
          />
          <path className="cls-31" d="M540.81,624.89c1.88-2.13,4.92-1.24,7.37-.92-1.88,1.95-4.96,1.26-7.36.98v-.06Z" />
          <path
            className="cls-55"
            d="M641.88,242.8c-2.59-1.41-2.27-4.68-2.89-7.17,1.83,1.78,3.13,4.51,2.95,7.14l-.06.03Z"
          />
          <path className="cls-31" d="M360.07,600.32c2.33-.7,5.59-1.79,6.86,1.13-2.19.2-4.96.33-6.87-1.07v-.05Z" />
          <path className="cls-55" d="M603.73,218.23c-2.3.6-5.53,1.62-6.82-1.11,2.17-.46,4.98-.42,6.83,1.06v.05Z" />
          <path className="cls-31" d="M119.17,567.33c2.18-.77,4.36-1.56,5.91,1.09-2.08.23-4.12.23-5.91-1.09Z" />
          <path className="cls-31" d="M73.69,561c2.07-.16,5.06-1.18,6.35,1.06-2.01.59-4.76.64-6.36-1.01v-.05Z" />
          <path className="cls-31" d="M562.36,210.55c-2.13.02-5.27,1.21-6.48-1.27,2.07-.56,4.84-.4,6.48,1.22v.04Z" />
          <path className="cls-31" d="M507.64,620.89c2.03-.19,4.84-.95,6.31.91-1.96.83-4.7.71-6.32-.86v-.05Z" />
          <path
            className="cls-55"
            d="M583.83,602.27c.49-2.3,3.02-3.43,5.15-3.48-.92,1.87-3.17,2.96-5.12,3.54l-.04-.05Z"
          />
          <path className="cls-31" d="M96.54,564.15c1.96-.23,4.12-1.46,5.5,1.12-1.96.25-3.95.66-5.5-1.12Z" />
          <path className="cls-31" d="M494.39,619.14c1.99-.33,4.14-1.48,5.56,1.1-2,.38-3.9.24-5.56-1.1Z" />
          <path className="cls-55" d="M594.31,216.59c-1.58.13-3.28.77-4.44-1.01,1.69-.61,3.18-.29,4.44,1.01Z" />
          <path className="cls-55" d="M593.88,595.42c.43-1.88,1.94-2.39,3.54-2.79-.72,1.52-1.75,2.63-3.54,2.79Z" />
          <path className="cls-55" d="M578.96,605.26c1.11-1.36,2.22-2.72,4.28-2.42-1.02,1.52-2.32,2.55-4.28,2.42Z" />
          <path className="cls-31" d="M64.04,225.22c-.87,2.14-2.29,1.82-3.86.86,1.07-1.26,2.45-1.1,3.86-.86Z" />
          <path className="cls-31" d="M540.72,207.23c-1.37.89-2.79.59-4.22.2,1.35-1.17,2.75-1.49,4.22-.2Z" />
          <path className="cls-31" d="M473.65,615.94c1.58-.19,3.28-.86,4.32,1.09-1.69.63-3.18.44-4.32-1.09Z" />
          <path className="cls-55" d="M620.31,221.58c-1.63.07-3.49.91-4.46-1.3,1.7-.31,3.24-.06,4.46,1.3Z" />
          <path className="cls-55" d="M627.9,571.7c.15-1.95,1.13-2.99,3.16-2.87-.51,1.56-1.6,2.47-3.16,2.87Z" />
          <path
            className="cls-43"
            d="M573.84,609.36c.02-.89.04-1.78.06-2.68.95,0,1.9,0,2.85-.01-.27,1.66-1.43,2.35-2.92,2.69Z"
          />
          <path className="cls-31" d="M56.84,557.91c1.37-.31,2.64-.35,3.21,1.31-1.41.4-2.46-.1-3.21-1.31Z" />
          <path className="cls-31" d="M57.06,226.58c-.78,1.46-2.05,1.26-3.34.99.85-1.2,1.97-1.52,3.34-.99Z" />
          <path className="cls-37" d="M393.81,57.26c.05,1.36.49,2.87-1.3,3.56-.37-1.48.15-2.63,1.3-3.56Z" />
          <path className="cls-53" d="M115.89,609.97c.92-.33,1.64-.13,2.09.78-1,.55-1.68.24-2.09-.78Z" />
          <path className="cls-8" d="M288.92,201.71c-.59,1.01-1.54,1-2.52.9.64-.84,1.38-1.43,2.52-.9Z" />
          <path className="cls-8" d="M295.92,200.75c-.51.88-1.11,1.07-1.84.24.55-.57,1.15-.72,1.84-.24Z" />
          <path className="cls-31" d="M561.88,617.5c.27-1.43,1.18-1.83,2.5-1.56-.52,1.02-1.26,1.7-2.5,1.56Z" />
          <path className="cls-8" d="M300.92,199.85c-.47.76-1.03,1-1.76.33.49-.63,1.08-.74,1.76-.33Z" />
          <path className="cls-55" d="M589.87,598.32c.23-1.23,1.02-1.65,2.19-1.56-.47.89-1.13,1.5-2.19,1.56Z" />
          <path className="cls-31" d="M554.84,622.01c.41-1.04,1.2-1.36,2.25-1.22-.44.98-1.12,1.51-2.25,1.22Z" />
          <path
            className="cls-31"
            d="M550.89,623.45c.04-.56.07-1.12.11-1.68.62.26,1.23.51,1.85.77-.44.77-1.07,1.11-1.96.91Z"
          />
          <path className="cls-43" d="M54.99,556.79c.33.16.67.31,1,.47-.33-.16-.67-.31-1-.47Z" />
          <path
            className="cls-6"
            d="M550.89,570.54c-2.9-97.67-1.4-195.44-3.48-293.08,1.06-16.3-4.03-34.64,2.5-49.82,8.02-12.53,22.12-2.99,22.04,9.11-.46,120.09-3.49,240.15-4.17,360.18,1.61,8.49-8.06,16.28-15.5,11.41-3.55-11.61-.3-25.36-1.38-37.62v-.17Z"
          />
          <path
            className="cls-6"
            d="M595.06,311.67c2.91.17,5.91-.12,8.83.13,1.23.07,1.99,1.23,1.99,2.49.32,2.53-2.51,4.5-4.48,2.37-2.67-2.8-6.24-1.99-9.53-1.16-2.54.43-5.09.2-7.63.24-1.61.12-3.36-.85-2.44-2.65.55-.82,1.81-.87,2.72-.98,3.42-.3,6.97-.56,10.4-.46l.14.02Z"
          />
          <path
            className="cls-6"
            d="M601.66,372.39c-6.61-1.98-13.33,2.33-19.87.91-1.2-1.14-.18-2.4,1.25-2.52,6.51-1.29,12.93-3.12,19.67-3.03,2.38-.08,3.37,1.56,2.31,3.69-.56,1.07-1.96,1.33-3.17,1l-.18-.04Z"
          />
          <path className="cls-55" d="M568.92,212.82c.97.04,1.94.08,2.9.12-.17,2.25-2.75,2.2-2.9-.12Z" />
          <path
            className="cls-1"
            d="M70.82,538.92c-21.39.62-13.33-10.52-14.96-26.08-.2-83.21-3.2-166.33-3.11-249.52.38-2.18-.87-6.18,1.94-6.52,1.78,3.49,1.36,9.85,5.28,12.49,1.4-8.27,6.76-7.82,7.54.8,2.24,3.1,5.98.36,4.8-2.84.73-5.02,5.64,2.67,8.43.48,4.29-3.52,9.75-5.75,15.5-5.12,2.3.72,1.86,3.04-.23,3.61-41.05,20.28-28.26,73.68-29.29,111.05,3,40.04-3.55,81.27,4.83,120.65,11.24,39.52,38.72,40.09,73.41,43.03,54.61,6.26,109.11,13.77,163.7,20.09,3.76,1.22,16.33-4.02,17.05-2.01-1.03,3.14-8.42,3.54-6.59,7.53,7.92,3.2,17.31,2.34,25.72,4.54,35.34,3.43,70.5,8.52,105.69,13.34,14.7,2.61,29.69,3.54,44.49,5.53,3.11.52,7.28-.08,8.73,3.42-143.51-16.76-291.28-36.06-432.74-54.48h-.18Z"
          />
          <path
            className="cls-1"
            d="M514.9,244.09c2.43,2.67,3.07,6.47,3.04,10-.08,25.2.63,50.4-.21,75.58-1.18,84.92-1.6,169.81-2.69,254.72,1.08,9.04-12.72,8.24-13.31.81-.15-29.39.85-59.33.57-88.92,1.05-79.55,1.75-159.1,1.55-238.67-.29-6.65,2.16-16.97,10.91-13.62l.14.08Z"
          />
          <path
            className="cls-1"
            d="M510.89,243.28c-.88.51-2.09.44-3.12.53-4.51-.09-8.73,2.06-13.24,1.91-34.96-.2-69.81,2.68-104.76,2.73-17.96.58-35.91,2.03-53.93,1.31-2.07-.05-4.69.01-5.86,1.96-1.69,2.72,1.87,4.13,3.32,5.81,3.56,3.83,8.08,7.11,7.81,13.03.01.5-.18,1.15-.73,1.11-.16,0-.33-.05-.52-.11-2.72-1.1-5.28-2.54-7.83-3.98-2.81-1.7-5.55-3.63-8.95-3.89-1.02-.05-1.88-.68-2.82-.88-5.63-.36-11.34-1.13-17.01-1.03-61.84,2.2-123.76,1.82-185.63,2.58-6.24.19-12.5.55-18.72,1.13-1.3.12-1.08-1.79-1.97-2.2-1.63-.95-3.91-.23-5.71-.1-2.69.38-5.35,1.05-7.58,2.73-1.84,1.68-4.07,3.44-6.45,1.89-1.38-.63-2.68-2.21-4.21-1.89-.92.33-.82,2.33-.64,3.3.42,1.91-1.62,2.82-3.19,2.47-3.25-.66-1.54-4.88-3.16-6.75-2.3-2.36-4.86-1.1-5.64,2.79-.2.55-.23,1.31-.37,1.75-.04.27-.3.28-.33.23-.13-.05-.29-.21-.46-.42-2.9-3.71-3.23-7.98-4.26-11.89-.38-2.6,1.84-4.47,4.27-4.57,59.08-.96,118.14-3.37,177.26-3.72,75.66-1.95,151.32-4.89,226.98-5.54,6.56.04,13.19.09,19.71.11.58,0,1.14-.05,1.64-.25.91-.32,1.33-1.63,2.43-1.59,7.31-.03,14.63-.4,21.93.32.48.06,1,.14,1.38.41.28.19.46.44.41.62l-.04.09Z"
          />
          <path
            className="cls-31"
            d="M486.05,242.07c-.35,1.74-2.52,1.76-3.97,1.67-6.25-.02-12.51-.07-18.77-.11-.26,0-.43-.1-.42-.31.44-1.79,2.64-1.57,4.1-1.54,6.32.09,12.74-.07,19.02.19l.04.09Z"
          />
          <path className="cls-31" d="M325.95,215.68c3.09-1.38,6.91-1.38,9.97-.04-2.92,1.82-6.92,1.58-9.97.1v-.05Z" />
          <path className="cls-31" d="M355.94,214.72c2.71-1.67,6.05-.85,9.04-.74-2.11,2.96-6.16,1.97-9.04.79v-.05Z" />
          <path className="cls-31" d="M316.99,215.82c.61-.93,1.27-.96,1.97-.1-.61.93-1.26,1.01-1.97.1Z" />
          <path
            className="cls-1"
            d="M340.83,271.61c2.16-9.28-13.12-14.82-11.18-19.91,1.18-1.93,3.8-2,5.87-1.95,30.63.44,61.16-1.85,91.78-2.03,26.71-2.37,53.83-.09,80.27-3.85.47.05.5.3.24.67-3.28,3.88-3.78,9-3.73,13.9.4,103.54-1.48,207.04-1.9,310.58-.39,8.26-4.24,22.24,8.49,22.13-.14,2.31-5.27,3.22-6.92,1.87-1.93-3.07-5.7-2.72-8.8-3.14-18.39-2.14-36.82-4.01-55.08-7.1-23.88-2.87-47.63-6.53-71.53-9.14-16.34-3.02-34.45-2.1-49.85-7.46-.86-3.93,5.74-4.15,6.9-7.4.74-1.56,2.64-1.82,4.06-2.55,18.38-7.28,30.8-25.61,33.25-44.74,2.42-62.83.85-125.94.76-188.83-.8-19.33-9.82-36.87-22.58-50.88l-.05-.17ZM391.83,340.9c.29,1.01-.17,3.06,1.27,3.62.54.25.93.65,1.09,1.22,2.13,6.5,6.64,11.3,11.56,15.83,10.3,9.5,23.06,10.09,36.03,9.03,1.9-.15,3.94-.26,4.98-2.17.29-.45.72-.76,1.25-.87,7.06-1.74,13.4-4.81,18.43-10.21,3.62-3.14,7.1-6.32,9.32-10.59,3.35-6.67,5.72-13.71,6.62-21.08,2.74-20.01-7.21-39.81-24.62-50-23.74-16.15-51.97-.28-64.44,22.39-3.06,5.19-6.05,10.76-3.69,17.09.28,1.31.65,2.92-.35,4.01-2.01,1.59-1.82,4.18-.84,6.31.83,1.85.51,3.9.59,5.85-.15,1.78-.67,3.66,1.05,4.93.3.25.64.56.76.92.24.97-.06,2.18.59,3.04.12.16.24.37.35.54l.06.14ZM380.94,539.56c-.02,3.08-.09,9.44,1.92,10.66.86.78,2.64,1.04,4.04,1.1,8.09.4,16.04,1.96,24.04,2.81,14.27.89,28.51,2.39,42.56,4.49,10.3,1.21,20.68,1.27,30.81,3.85,1.98.57,4.96.78,6.22-.9,1.39-1.72,1.34-4.36,1.26-6.51-.12-2.79-.33-5.62-1.82-8.14-.31-.56-.64-1.28-.58-1.89.04-.85.59-1.65,1-2.43,2.68-4.91,2.32-10.05.17-15.01-.28-.7-.64-1.47-.64-2.19-.04-.65.32-1.4.67-2,2.63-4.18,1.3-8.76,1.05-13.23.03-1.9-1.89-2.54-3.52-2.43-6.25.25-12.24-1.42-18.42-2.06-4.16-.49-8.34.09-12.5-.5-15-1.71-30.11-2.52-45.06-4.64-8.15-1.06-16.42-.05-24.49-1.83-5.79-1.49-6.64.28-6.74,5.97-.15,6.05.81,12.18-1.48,18.13-1.08,2.4-.84,5.24.14,7.65,1.31,3.34,1.46,6.29,1.39,9.14ZM464.9,403.53c.13-6.4-5.56-11.04-11.96-9.36-8.47,1.99-10.83,13.4-3.13,17.92,6.6,3.8,15.35-.07,15.09-8.37v-.19ZM427.93,402.12c.04-3.21-.97-6.34-2.98-7.74-2.79-2.18-8.44-2.09-11.37-.29-7.25,3.92-5.54,15.82,2.71,17.34,6.93,1.44,11.87-2.17,11.64-9.1v-.21Z"
          />
          <path className="cls-31" d="M450.95,612.5c-2.72.32-5.77-.04-8-1.76,2.67-.54,6.25-.96,8.01,1.69l-.02.07Z" />
          <path
            className="cls-31"
            d="M138.17,548.61c1.53.07,3.38-.09,4.85.1-1.91,3.08-5.03,3.09-7,.03.23-.17,1.67-.07,2.03-.13h.12Z"
          />
          <path
            className="cls-31"
            d="M138.12,548.62c-1.96.05-4.11.17-6.05.01-.11-.08-.05-.33-.07-.5,0-.41-.06-.83.02-1.23,2.2-.05,5.06-1.05,6.13,1.64l-.02.08Z"
          />
          <path className="cls-31" d="M459.93,613.58c-.83.08-1.53-.14-2.03-.84,1.4-1.46,1.75-.39,2.03.84Z" />
          <path
            className="cls-31"
            d="M107.96,543.79c1.93.11,4.59-.77,6.02.95,0,.13-.31.19-.46.28-.37.16-.76.34-1.14.47-1.78.8-3.64.17-4.44-1.63l.02-.07Z"
          />
          <path className="cls-31" d="M85,540.85c1.73-.01,3.58-.68,4.99.94-1.95,1.2-3.79,1.84-4.99-.94Z" />
          <path className="cls-31" d="M71.01,538.89c1.51-.27,2.74,0,3.17,1.72-1.42.1-2.81.13-3.17-1.72Z" />
          <path className="cls-31" d="M63.01,538.67c1.03-1.12,2.04-1.14,3.02.06-1.03,1.17-2.04,1.14-3.02-.06Z" />
          <path
            className="cls-53"
            d="M470.98,655.05c-.2,1.22.45,3.22-.81,4.11-.93.61-2.35.59-3.24.4-2.1-.41-3.53-2.19-3.82-4.26-1.38-9.84-4.1-19.32-5.88-29.09-.17-1-.29-2.12.7-2.76.62-.42,1.4-.41,1.79.06,4.88,8.88,7.24,18.94,10.91,28.34.44.98.39,2.18.34,3.2Z"
          />
          <path className="cls-37" d="M399.95,52.84c-.31-.31-.62-.61-.93-.92.31.31.62.61.93.92Z" />
          <path
            className="cls-4"
            d="M341.63,548.89c-17.14,16.59-42.73,11.25-64.06,8.27-44.27-5.17-88.48-11.31-132.78-16.3-13.52-1.96-27.8-2.01-40.98-5.5-35.25-12.16-37.15-55.83-36.1-87.59,1.81-48.52-5.71-97.88.92-145.97,10.15-33.92,27.48-38.96,60.5-37.74,56.18-.37,112.4-.23,168.53-2.26,7.3-.43,14.55.34,21.81.83.9.05,2.02.28,2.38,1.2,25.02,43.19,21.13,62.77,21.78,110.64-2.02,46.45,1.33,93.3-3.75,139.49-1.27,12.69-9.57,23.64-11.91,35.66,3.24,6.13,9.19-1.91,13.63-.8l.03.08Z"
          />
          <path
            className="cls-63"
            d="M341.86,548.62c-3.39-.29-5.85,2.09-8.84,3.16-4.12,1.18-6.62-2.93-4.36-6.41,12.96-23.26,14.05-49.75,13.66-75.73-1-54.51,5.61-110.74-2.47-164.71-3.23-13.26-9-25.22-16.37-36.45-5.26-8.68,5.02-3.52,8.5-1.04,21.98,9.92,31.29,37.13,31.87,59.95,0,59.56.74,119.17-.38,178.73-1.2,16.51-7.34,31.88-21.44,42.44l-.16.05Z"
          />
          <path
            className="cls-63"
            d="M380.94,539.41c.06-2.76-.11-5.72-1.4-8.99-.98-2.41-1.21-5.25-.14-7.65,2.29-5.95,1.33-12.07,1.48-18.13.08-6.95,1.7-7.21,7.95-5.72,7.68,1.44,15.55.58,23.28,1.58,14.95,2.12,30.06,2.93,45.06,4.64,4.16.59,8.34.01,12.5.5,6.17.65,12.17,2.32,18.42,2.06,1.61-.1,3.58.53,3.52,2.43.25,4.47,1.58,9.05-1.05,13.23-.34.6-.7,1.35-.67,2,0,.72.36,1.49.64,2.19,2.15,4.96,2.51,10.1-.17,15.01-.4.78-.96,1.58-1,2.43-.06.61.27,1.33.58,1.89,1.49,2.51,1.7,5.35,1.82,8.14.09,2.15.14,4.8-1.25,6.51-1.27,1.68-4.23,1.47-6.22.9-10.13-2.58-20.51-2.64-30.81-3.85-14.05-2.1-28.3-3.6-42.56-4.49-8-.85-15.94-2.41-24.03-2.81-1.4-.06-3.18-.32-4.04-1.1-2.04-1.26-1.93-7.71-1.92-10.81Z"
          />
          <path
            className="cls-4"
            d="M466.8,356.76c-4.96,6.13-12.47,9.47-19.98,11.01-3.23.05-6.47-.13-9.69-.06-6.73.61-13.38-.91-19.03-4.29-19.91-10.76-28.52-33.25-23.86-55,.54-2.17.27-4.55,1.18-6.59,5.68-10.84,12.65-20.23,24.23-25.83,8.43-4.27,19.35-5.87,27.66-1.67,4.8,2.21,9.32,6.43,12.87,11.64,2.81,3.48,5.82,7,7.87,10.89,9.51,17.03,7.45,39.63-5.49,54.77-.55.7-1.31,1.39-1.09,2.36.27,1.22,1.49,1.57,2.64,1.17,1.37-.46,2.71.02,2.73,1.44l-.03.16ZM460.94,319.46c-.03-7.83-2.32-14.96-8.25-20.46-1.26-1.18-2.87-3.11-4.68-1.82-1.64,1.05-1.13,2.74,0,4,8.36,9.71,9.69,24.62,1.94,35.19-.59.84-1.34,1.98-.9,2.96.26.61,1.11,1.12,1.68.91,6.5-4.97,10.44-12.33,10.21-20.6v-.18Z"
          />
          <path
            className="cls-63"
            d="M467.04,356.57c-.36-.26-.52-.86-.93-1.1-.5-.36-1.24-.27-2-.1-1.71.61-3.3-.79-2.39-2.43,8.21-9.74,12.57-21.32,12.21-33.75.01-13.14-5.79-24.29-14.24-33.96-11.94-18.5-34.73-16.23-50.01-2.69-6.22,5.41-10.7,12.52-14.58,19.83-.78,1.09-1.84,2.02-2.37,3.28-.94.67-2.2,12.65-3.28,8.94-2.39-7.86,2.63-14.33,6.36-20.5,7.1-10.79,16.79-19.24,29.14-23.23,22.63-8.03,47.28,10.12,54.94,31.23,4.35,11.95,3.61,25.91-1.06,37.83-2.3,6.44-5.89,13.08-11.67,16.69l-.1-.04Z"
          />
          <path
            className="cls-28"
            d="M389.9,315.55c1.74-4.03,1.05-9.05,4.35-12.45,1.32-1.49-.14,4.8-.12,5.31-4.61,21.82,4.08,44.3,24.01,55.1,5,2.86,10.71,4.69,16.54,4.39,3.97-.16,7.92-.09,11.89.04.83.23.06,1.14-.36,1.56-1.22,1.09-2.92,1.1-4.47,1.25-13.05,1.2-26.5.03-36.14-9.24-4.86-4.5-9.34-9.31-11.46-15.78-.34-.94-.31-2.21-1.3-2.74-.32-.19-.65-.36-.8-.64-.24-.42-.11-1.07-.27-1.6-.25-.98-.93-1.85-.91-2.88-.3-2.19.2-4.01-.01-5.95-.04-1.22-1.67-1.9-1.92-2.94-.06-.88-.14-1.83.22-2.67,1.59-3.28.22-7.14.72-10.6l.03-.16Z"
          />
          <path
            className="cls-45"
            d="M464.9,403.72c.26,8.29-8.5,12.16-15.09,8.36-7.7-4.52-5.34-15.93,3.13-17.92,6.4-1.68,12.09,2.95,11.96,9.36v.19Z"
          />
          <path
            className="cls-57"
            d="M427.93,402.33c.24,6.93-4.7,10.55-11.64,9.1-8.25-1.52-9.97-13.43-2.71-17.34,2.93-1.79,8.58-1.89,11.37.29,2.06,1.41,3.07,4.72,2.98,7.94Z"
          />
          <path className="cls-28" d="M389.89,318.69c-.26,2.63.91,5.78-.9,8.06-1.44-2.68-2.26-6.16.84-8.07h.06Z" />
          <path
            className="cls-28"
            d="M389.06,329.64c3,1.29,1.61,4.61,1.77,7.11-3.19-1.12-1.45-4.66-1.84-7.09l.06-.02Z"
          />
          <path className="cls-28" d="M391.99,342.67c1.21.17,1.89.84,1.91,2.09-1.26-.13-1.9-.83-1.91-2.09Z" />
          <path className="cls-28" d="M390.97,338.69c.32.7.65,1.39.97,2.09-.74-.5-.97-1.24-.97-2.09Z" />
          <path
            className="cls-63"
            d="M460.94,319.64c.23,8.27-3.71,15.63-10.21,20.6-.56.22-1.42-.3-1.68-.91-.44-.98.31-2.12.9-2.96,6.02-8.09,6.13-17.73,3.17-26.91-1.17-3.03-3.02-5.7-5.11-8.28-1.58-1.7-1.42-3.72.91-4.4,1.57-.22,2.68,1.25,3.77,2.22,5.98,5.54,8.25,12.76,8.25,20.64Z"
          />
        </g>
      </g>
    </StyledSVG>
  );
};

export default TV_PHD_3D;
